import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../../../pdc-platform/src/ts/Glob';
import DateField from './DateField';
import NumberField from './NumberField';
import SelectField from './SelectField';
import NumberSpinnerExtended from './NumberSpinnerExtended';
import StringField from './StringField';
import { ColorBoxField } from './ColorBoxField';
import { IPopupOptions } from '../../../pdc-platform/src/ts/actions/DialogActions';
import * as DateTimeFunctions from '../../../_common/platform/ts/DateTimeFunctions';
import * as Utilities from '../../../_common/platform/ts/Utilities';
import { IValuesCollection } from '../ts/appTheme';
import { ATTRIBUTE_TYPES } from '../ts/ConfigurationConstants';
import * as Globalization from '../../../_common/platform/ts/Globalization';

const ResourceBrowser = require('pdc-widget-resource-manager/src/ts/react/ResourceBrowser'); // for Icon(GIS)
const Globalize = require('pdc-platform-Globalize');

// steps:
const timeStepDefault = 30; // minutes
const dateStepDefault = 10; // days
const numberStepDefault = 1;
const stepMin = 0; // and use minConstraintAllowEqual = false -> instead of "positive"
const timeStepMin = 1; //-1440;
const timeStepMax = 1439; //1440;

const precisionDefault = 1;

// time:
const TimeValueFormat = DateTimeFunctions.TimeValueFormat; // 'yyyy-MM-ddTHH:mm:ss'
const TimeDisplayFormat = DateTimeFunctions.TimeDisplayFormat; // 'HH:mm:ss'
const TimeDisplayFormatShort = DateTimeFunctions.TimeDisplayFormatShort; // 'HH:mm'
const timeInfinityMinus = '00:00:00';
const timeInfinity = '24:00:00';

//LL: 30.05.19: my flag:  (and don't forget to change in Utilities.evaluateColor, it must call function defined here ?  No)
//    for outer world, class Interval works with 'yyyy-MM-ddTHH:mm:ss' always
const TimeValuesAsDate = true; // old, as 'yyyy-MM-ddTHH:mm:ss'
//const TimeValuesAsDate = false;  // new, as 'HH:mm:ss'

// date:
const DateValueFormat = 'yyyy-MM-dd';
const DateTimeValueFormat = 'yyyy-MM-dd HH:mm:ss';
const DateTimeValueFormatT = 'yyyy-MM-ddTHH:mm:ss';

// time:
function convertTimeValueAsDateToString(dateString: string) {
    //LL; from format 'yyyy-MM-ddTHH:mm:ss' to format 'HH:mm:ss'
    return DateTimeFunctions.convertTimeValueAsDateToString(dateString);
}

// date:
function getDateTimeValueFormat(dataType: string) {
    // date or datetime
    if (DateTimeFunctions.isTypeOfDatetime(dataType)) {
        return DateTimeValueFormat;
    } else {
        return DateValueFormat;
    }
}

function getStepDefault(dataType: string) {
    let result = 1;

    switch (dataType) {
        case 's':
        case 'string':
            break;
        case 'i':
        case 'r':
        case 'number':
            result = numberStepDefault;
            break;
        case 'date':
        case 'datetime':
            result = dateStepDefault;
            break;
        case 'time':
            result = timeStepDefault;
            break;
        //default:
    }

    return result;
}

function validateWhole(value, type) {
    let errors = [];
    let valid = DiscreteIntervals.validateDiscreteIntervals(value, type);

    if (valid !== true) {
        errors.push('There are errors in Discrete Intervals');
    }

    return errors;
}

function getMinTimeDate() {
    // NOT  new Date(0);  // 03:00:00 with TZ
    return new Date(0, 0, 0, 0, 0, 0);
}
function getMaxTimeDate() {
    return new Date(0, 0, 0, 23, 59, 59, 999);
}

export function getIntervalPlaceholderValue(left, right, type, inHTML) {
    // left can be null, -Infinity,  right can be Infinity

    //LL: 07.06.19:   // was '-', bad for negative and dates
    let separator = ' \u00A6 '; // it is "Изломанная вертикальная черта" ("Broken vertical bar")

    if (left == null) {
        if (type === 'boolean') {
            if (right === true) {
                return 'for True value';
            }
            if (right === false) {
                return 'for False value';
            }
        }

        return 'for null value';
    }

    if (left === -Infinity && right === Infinity) {
        return left.toString() + separator + right.toString();
    }

    let rightStr: any = right;

    if (type === 'time') {
        rightStr = rightStr !== Infinity ? convertTimeValueAsDateToString(rightStr) : timeInfinity;
    } else if (type === 'datetime') {
        //LL: our DateField returns:
        //    isDateTime => "2019-05-18T03:08:00", isDate => "2019-05-18"
        if (rightStr !== Infinity) {
            let dt = Date.parse(rightStr); // for "2019-05-18T03:08:00"
            if (!isNaN(dt)) {
                let d = new Date(dt);
                rightStr = Globalize.formatDate(d, {
                    raw: DateTimeValueFormat
                });
            }
        }
    } else {
        rightStr = rightStr != null ? rightStr.toString() : '';
    }

    //  '\u2264' <=   '\u2265'  UTF-16(hex) 0x2265  UTF-8 e289a5 &ge; ≥ >=     \u003e >
    //   https://mathiasbynens.be/notes/javascript-escapes
    //      UTF-8 (hex)	0xE2 0x89 0xA5 (e289a5)   '\u{1d306}' '\u{e289a5}'
    //     (The unicode for ≥ is "U+ 2265".)

    // https://stackoverflow.com/questions/12140003/ascii-code-for-less-than-or-equal-to
    //   The character ≤ isn't in the ASCII table. However, there are several ways to embed it in HTML.
    //   Firstly, using HTML entities: either &le;, &#8804;, or &#x2264.
    //     Just place this code in your HTML where you want the ≤ symbol to be.
    //   Alternatively, ensure that your html file is utf8 encoded, and include
    //    the meta tag <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" /> in the <head> of your document.
    //    You can then copy and paste the ≤ character directly into your document.

    //  He:  !!!
    //  I always just underline < and > which are standard keyboard characters.
    //  It may be a little clugey, but it works, and it saves remembering numbers.

    //LL:  won't work, Labels are returned by backend as values !!!  Suppose, they are converted (truncated ?) to ASCII ?

    //   https://pixelplus.ru/samostoyatelno/stati/vnutrennie-faktory/tablica-simvolov-unicode.html
    //   https://unicode-table.com/ru/
    let leftStr: any = left;

    if (leftStr == null || leftStr === -Infinity) {
        leftStr = '\u003C'; // "<";
        //leftStr = (inHTML ? '&lt' : '\u003C');
    } else {
        if (type === 'time') {
            leftStr = convertTimeValueAsDateToString(leftStr);
        } else if (type === 'datetime') {
            //LL: our DateField returns:
            //    isDateTime => "2019-05-18T03:08:00", isDate => "2019-05-18"
            let dt = Date.parse(leftStr); // for "2019-05-18T03:08:00"
            if (!isNaN(dt)) {
                let d = new Date(dt);
                leftStr = Globalize.formatDate(d, { raw: DateTimeValueFormat });
            }
        } else {
            leftStr = leftStr.toString();
        }

        if (right === Infinity) {
            //leftStr = '\u2265' + leftStr;  //  >=
            leftStr = (inHTML ? '\u2265' : '>=') + leftStr; //  >=   OK
            //leftStr = (inHTML ? '\u2265' : '≥')  + leftStr;  //  >=  NO just =

            //leftStr = (inHTML ? '\uD834\uDF06' : '\uD834\uDF06')  + leftStr;
            rightStr = '';
        } else {
            //LL: 15.05.19: case when only one value, not interval:
            if (type === 'i' && right - left <= 1) {
                //LL: here right != Infinity & left != -Infinity
                rightStr = '';
            } else {
                leftStr = leftStr + separator; // '-';
            }
        }
    }

    //let placeholderValue = rightStr;
    let placeholderValue = leftStr + rightStr;

    return placeholderValue;
}

export const dataTypes = ['number', 'date', 'datetime', 'time', 'string', 'boolean'];

//LL: 28.06.19: Leo wants enhancement: to be able to map (отображение) any type to any other type
//     To icon (GIS), to dates, to numbers ...
//LL: actually it is a type of Mapped Value
export enum DiscreteIntervalsKind {
    label = 0, //  done
    color = 1, //  done
    icon = 2, // see GIS, path to image
    //string,   //  same as "label"
    number = 3, //  or i / r separate,  let it be all variants with "number" = "real"
    integer = 4,
    real,
    date,
    datetime,
    time,
    boolean
}

export function DiscreteIntervalsKind_toString(dik: any) {
    // dik: DiscreteIntervalsKind
    // https://stackoverflow.com/questions/40752830/javascript-print-the-name-of-an-enum-from-a-value
    for (let prop in DiscreteIntervalsKind) {
        if (DiscreteIntervalsKind[prop] === dik) {
            if (prop === 'icon') {
                return 'image';
            }
            return prop;
        }
    }
    return dik.toString();
}

export interface IKindListForDiscreteMapping {
    kind: number;
    name: string;
    emptyMappedValue;
    canContinuous: boolean;
}

export function getKindList_forDiscreteMapping() {
    const result: IKindListForDiscreteMapping[] = [];

    _.each(KindList, (obj, key) => {
        //if (!(obj.kind === DiscreteIntervalsKind.real || obj.kind === DiscreteIntervalsKind.integer || obj.kind === DiscreteIntervalsKind.date)) {
        if (!(obj.kind === DiscreteIntervalsKind.real || obj.kind === DiscreteIntervalsKind.integer)) {
            result.push({
                kind: obj.kind,
                name: obj.columnHeader,
                emptyMappedValue: obj.emptyMappedValue,
                canContinuous: obj.canContinuous
            });
        }
    });
    return result;
}

function getKindDescrObject(_kind: DiscreteIntervalsKind) {
    let kindObj = KindList[0]; //  as default,  or null ?

    _.each(KindList, (obj, key) => {
        if (obj.kind === _kind) {
            kindObj = obj;
            return;
        }
    });

    return kindObj;
}

function getEmptyMappedValue_Date() {
    //return null;  //LL: bad, in such case must validate that all "labels" are not null
    const DateFormat = 'yyyy-MM-dd';
    let D = new Date(); // today or 0 (=1970-01-01)
    return Globalize('en').formatDate(D, { raw: DateFormat });
}

function getEmptyMappedValue_DateTime() {
    //return null;  //LL: bad, in such case must validate that all "labels" are not null
    const DateFormat = 'yyyy-MM-ddTHH:mm:ss';
    let D = new Date(); // today or 0 (=1970-01-01)
    return Globalize('en').formatDate(D, { raw: DateFormat });
}

function getEmptyMappedValue_Time() {
    //return null;  //LL: bad, in such case must validate that all "labels" are not null

    //LL: as formatted date:  "1899-12-31T02:30:00"
    //let t: any = Globalization.parseDate(timeInfinityMinus, { raw: TimeDisplayFormat });
    //t = Globalize.formatDate(t, { raw: TimeValueFormat });
    //return t;

    //LL: let it be "value" always just Time, conversion in RenderComponent:
    return timeInfinityMinus;
}

function getEmptyMappedValue_Boolean() {
    return true;
}

interface IDiscreteIntervalsKindRenderComponentResult {
    label?: any;
    title?: string;
    isLast?: boolean;
    glob?: any;
}

function Label_RenderComponentResult(props: IDiscreteIntervalsKindRenderComponentResult) {
    let label = props.label;

    if (label == null || label === '') {
        label = props.title;
    } else {
        label = label.toString(); // for Numbers, Dates, Time
    }

    if (!props.isLast) {
        label += '; ';
    }

    return (
        <span className="text" title={props.title}>
            {label}
        </span>
    );
}

function Color_RenderComponentResult(props: IDiscreteIntervalsKindRenderComponentResult) {
    let color = props.label;

    if (color != null) {
        let styleColor: React.CSSProperties = {
            backgroundColor: color
        };

        return <div className="color" style={styleColor} title={props.title}></div>;
    } else {
        return (
            <p className="text" title={props.title}>
                {'not_set'}
            </p>
        );
    }
}

function Icon_RenderComponentResult(props: IDiscreteIntervalsKindRenderComponentResult) {
    let path = props.label;

    if (path == null || path === '') {
        return (
            <p className="text" title={props.title}>
                {'not_set'}
            </p>
        );
    } else {
        return (
            <span className="image" title={props.title}>
                <img src={path} alt="not_set" width="20" height="19" />
            </span>
        );
    }
}

interface IDiscreteIntervalsKindRenderComponentOptions {
    disabled?: boolean;
    allowTransparency?: boolean;
    isDateTime?: boolean;
    showSeconds?: boolean;
    placeholder?: string;
}

interface IDiscreteIntervalsKindRenderComponentProperties {
    value?: any;
    options?: IDiscreteIntervalsKindRenderComponentOptions;
    allowNull?: boolean;
    themeObj?: IValuesCollection;
    glob?: IGlob;
    onChange?(value): void;
}

export type RenderComponentType = (props: IDiscreteIntervalsKindRenderComponentProperties) => React.JSX.Element;

function Label_RenderComponent(props: IDiscreteIntervalsKindRenderComponentProperties) {
    let disabled = false;
    let placeholderValue = '';

    if (props.options != null) {
        if (props.options.disabled != null) {
            disabled = props.options.disabled;
        }
        if (props.options.placeholder != null) {
            placeholderValue = props.options.placeholder;
        }
    }

    if (!disabled) {
        return (
            <StringField
                value={props.value}
                placeholder={placeholderValue}
                changeOnBlurOnly={true}
                applyOnEnter={true}
                onChange={props.onChange}
            />
        );
    } else {
        return <input className="form-control" type="text" disabled={true} value={props.value} />;
    }
}

export function Color_RenderComponent(props: IDiscreteIntervalsKindRenderComponentProperties) {
    let allowTransparency = false;

    if (props.options != null && props.options.allowTransparency != null) {
        allowTransparency = props.options.allowTransparency;
    }

    return (
        <ColorBoxField
            value={props.value}
            hideTransparency={!allowTransparency}
            showText={true}
            readOnly={false}
            disabled={false}
            themeObj={props.themeObj}
            glob={props.glob}
            onChange={props.onChange}
        />
    );
}

function Number_RenderComponent(props: IDiscreteIntervalsKindRenderComponentProperties) {
    return (
        <NumberField
            value={props.value}
            integer={false}
            applyOnEnter={true}
            allowNull={true}
            onChange={props.onChange}
        />
    );
}

function Integer_RenderComponent(props: IDiscreteIntervalsKindRenderComponentProperties) {
    return (
        <NumberField
            value={props.value}
            integer={true}
            applyOnEnter={true}
            allowNull={true}
            onChange={props.onChange}
        />
    );
}

export function DateTime_RenderComponent(props: IDiscreteIntervalsKindRenderComponentProperties) {
    let isDateTime = false;

    if (props.options != null) {
        isDateTime = props.options.isDateTime === true;
    }

    let typeParam: string = 'date'; //  see  DateFieldTypes = 'date' | 'time' | 'datetime';
    let displayDateFormat = DateValueFormat;

    if (isDateTime) {
        typeParam = 'datetime';
        displayDateFormat = DateTimeValueFormat;
    }

    let allowNull = false;
    let hideClearButton = true;

    if (props.allowNull != null) {
        allowNull = props.allowNull;
        hideClearButton = !props.allowNull;
    }

    //LL: our DateField returns:
    //    isDateTime => "2019-05-18T03:08:00", isDate => "2019-05-18"
    return (
        <DateField
            value={props.value}
            type={typeParam}
            displayDateFormat={displayDateFormat}
            displayDateTimeFormat={displayDateFormat}
            hideClearButton={hideClearButton}
            allowNull={allowNull}
            onChange={props.onChange}
        />
    );
}

export function Time_RenderComponent(props: IDiscreteIntervalsKindRenderComponentProperties) {
    let timeStepValue = 30; // minutes

    //LL: decide later which is needed or both.  Option ?
    //let timeDisplayFormat_inDateField = TimeDisplayFormat;
    let timeDisplayFormat_inDateField = TimeDisplayFormatShort;
    //LL: 27.01.20: but "rollers" show only Hour and Minute, no Seconds, so Seconds cannot be changed.  In input part ?
    if (props.options != null) {
        if (props.options.showSeconds === true) {
            timeDisplayFormat_inDateField = TimeDisplayFormat;
        }
    }

    let allowNull = false;
    let hideClearButton = true;

    if (props.allowNull != null) {
        allowNull = props.allowNull;
        hideClearButton = !props.allowNull;
    }

    //LL: let it be "value" always just Time, conversion here for DateField:
    let value = props.value;

    if (value != null) {
        //LL: as formatted date:  "1899-12-31T02:30:00"
        let t = Globalization.parseDate(props.value, {
            raw: TimeDisplayFormat
        });
        //LL: 06.12.19:
        if (t == null) {
            t = Globalize('en').parseDate(props.value); //LL: 27.01.20: add ("en")
        }

        if (t != null && !Number.isNaN(t)) {
            //value = Globalize.formatDate(t, { raw: TimeValueFormat });

            //LL: 06.12.19:
            //LL:   for Danish it will be "2019-12-06T22.06.00"  although used 'yyyy-MM-ddTHH:mm:ss'
            //LL:   error for Danish culture,  Time separator is '.'

            //LL: 06.12.19: try  and also see
            //let value2 = Globalize.formatDate(t, { sceleton: 'yyyy-MM-ddTHH:mm:ss' }); // 6.12.2019
            //let value3 = Globalize.formatDate(t, { sceleton: 'Hmmss' }); //  6.12.2019     !!??
            //let value4 = t.toISOString().substr(0, 19);  //  also bad: 2019-12-06T19.06.00  TZ GMT+3 !!  19 instead of 22
            //let v = 3;

            //LL: 17.12.19: for Danish culture returns 'HH.mm.ss', not 'HH:mm:ss'
            //LL: 17.12.19:
            // http://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
            //       see Pattern fields and the Date Field Symbol Table
            // https://github.com/globalizejs/globalize/blob/master/doc/api/date/date-formatter.md
            //       see  { skeleton: "EHms" }	"Tue 17:55:00"
            value = Globalize('en').formatDate(t, { raw: TimeValueFormat });
        }

        //LL: 06.12.19:
        //LL:   for Danish it will be "2019-12-06T22.06.00"  although used 'yyyy-MM-ddTHH:mm:ss'
        //LL:   error for Danish culture,  Time separator is '.'

        //LL: 06.12.19:
        // Метод toISOString() возвращает строку в формате ISO (расширенный формат ISO 8601),
        // который можно описать следующим образом: yyyy-MM-DDTHH:mm:ss.sssZ.
        // Часовой пояс всегда равен UTC, что обозначено суффиксом "Z"

        // https://github.com/globalizejs/globalize/issues/760
        //    Eg. for danish, this is the standard 27-11-2017 11:23, but CLDR thinks it's 27/11/2017 11.23 (notice the dot time separator).
        //    ...
        //    Until then can you explain why: Globalize.formatDate(new Date(), { raw: "HH:mm" }) replaces ":" with "." ?

        //LL: 06.12.19:  try sceleton
        //   https://github.com/globalizejs/globalize/blob/master/doc/api/date/date-formatter.md
        //   options.raw
        //      String value indicating a machine raw pattern (anything in the "Sym." column) eg. { raw: "dd/mm" }.
        //      Note this is NOT recommended for i18n in general. Use skeleton instead.
        //   options.skeleton
        //      String value indicating a skeleton (see description above), eg. { skeleton: "GyMMMd" }.
        //      Skeleton provides a more flexible formatting mechanism than the predefined list full, long, medium,
        //      or short represented by date, time, or datetime.
        //      Instead, they are an open-ended list of patterns containing only date field information,
        //      and in a canonical order.
        //      For a complete list of skeleton patterns check the unicode CLDR documentation:
        //          http://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
    }

    return (
        <DateField
            type={'time'}
            value={value}
            displayDateTimeFormat={timeDisplayFormat_inDateField}
            intervalMinutes={timeStepValue}
            options={{ formattedTime: true }}
            hideClearButton={hideClearButton}
            allowNull={allowNull}
            onChange={props.onChange}
        />
    );
}

export function Boolean_RenderComponent(props: IDiscreteIntervalsKindRenderComponentProperties) {
    //LL: don't like render of BooleanField, so use Select. But it deals with Strings or Numbers
    //LL: Only result will be Boolean
    let optionsBool = {
        values: ['true', 'false'],
        //values: [true, false],
        display: ['true', 'false']
    };

    let v = props.value;

    if (v != null) {
        v = v.toString();
    }

    return <SelectField value={v} onChange={props.onChange} options={optionsBool} />;
}

function Icon_RenderComponent(props: IDiscreteIntervalsKindRenderComponentProperties) {
    //LL:   see /GIS/tsx/AttrQueryGISIconPropertyField.tsx
    //LL: see const ResourceBrowser = require('pdc-widget-resource-manager/src/ts/react/ResourceBrowser');

    const handleValueChange = (value) => {
        // see for value:
        //if (resobj != null) {  //LL
        //    obj.url = resobj.url;
        //    obj.res = resobj.res;
        //    obj.iconPath = resobj.url + "/" + resobj.res.thumbnail;
        //}

        if (typeof props.onChange === 'function') {
            props.onChange(value.iconPath);
        }
    };

    //LL:   see /GIS/tsx/AttrQueryGISIconPropertyField.tsx
    const handleResourceManagerInsert = () => {
        //let instanceId = 'resource-browser-GIS-icon';  // was in GIS
        let instanceId = 'resource-browser-DiscreteIntervals-icon';

        ResourceBrowser.ResourceBrowser.createDialog(
            props.glob,
            instanceId,
            () => {
                let resobj = ResourceBrowser.ResourceBrowser.getFirstSelectedResource(instanceId);
                //let obj: any = _.clone(self.props.value || {});  // was in GIS
                let obj: any = {};
                //obj.iconPath = { attribute: resobj.url + "/" + resobj.res.thumbnail };  // was in GIS
                if (resobj != null) {
                    obj.url = resobj.url;
                    obj.res = resobj.res;
                    obj.iconPath = resobj.url; //LL: by OE
                    //LL: was: obj.iconPath = resobj.url + "/" + resobj.res.thumbnail;
                }
                handleValueChange(obj);
            },
            2000 // zIndex
        );
    };

    const processIconPathChange2 = (value) => {
        if (typeof props.onChange === 'function') {
            props.onChange(value);
        }
    };

    //LL:   see /GIS/tsx/AttrQueryGISIconPropertyField.tsx
    let image;

    if (props.value != null && props.value !== '') {
        image = (
            <span className="image-container">
                <img src={props.value} width="20" height="19" />
            </span>
        );
    }

    return (
        <div className="form-control icon-kind-content">
            <span className="glyphicon glyphicon-cog cog-container" onClick={handleResourceManagerInsert}></span>
            {image}
            <span className="path-container" title={props.value}>
                <StringField value={props.value} changeOnBlurOnly={true} onChange={processIconPathChange2} />
            </span>
        </div>
    );
}

const KindList = [
    //{ kind: DiscreteIntervalsKind.label, columnHeader: "Label", emptyMappedValue: "", renderComponent: Label_RenderComponent, renderComponentResult: Label_RenderComponentResult, canContinuous: false },
    {
        kind: DiscreteIntervalsKind.label,
        columnHeader: 'String',
        emptyMappedValue: '',
        renderComponent: Label_RenderComponent,
        renderComponentResult: Label_RenderComponentResult,
        canContinuous: false
    },
    {
        kind: DiscreteIntervalsKind.color,
        columnHeader: 'Color',
        emptyMappedValue: 'black',
        renderComponent: Color_RenderComponent,
        renderComponentResult: Color_RenderComponentResult,
        canContinuous: true
    },
    {
        kind: DiscreteIntervalsKind.icon,
        columnHeader: 'Image',
        emptyMappedValue: '',
        renderComponent: Icon_RenderComponent,
        renderComponentResult: Icon_RenderComponentResult,
        canContinuous: false
    },
    {
        kind: DiscreteIntervalsKind.number,
        columnHeader: 'Number',
        emptyMappedValue: 0,
        renderComponent: Number_RenderComponent,
        renderComponentResult: Label_RenderComponentResult,
        canContinuous: true
    },
    {
        kind: DiscreteIntervalsKind.real,
        columnHeader: 'Number',
        emptyMappedValue: 0,
        renderComponent: Number_RenderComponent,
        renderComponentResult: Label_RenderComponentResult,
        canContinuous: true
    },
    {
        kind: DiscreteIntervalsKind.integer,
        columnHeader: 'Number',
        emptyMappedValue: 0,
        renderComponent: Integer_RenderComponent,
        renderComponentResult: Label_RenderComponentResult,
        canContinuous: true
    },
    {
        kind: DiscreteIntervalsKind.date,
        columnHeader: 'Date',
        emptyMappedValue: getEmptyMappedValue_Date(),
        renderComponent: DateTime_RenderComponent,
        renderComponentResult: Label_RenderComponentResult,
        canContinuous: true
    },
    {
        kind: DiscreteIntervalsKind.datetime,
        columnHeader: 'DateTime',
        emptyMappedValue: getEmptyMappedValue_DateTime(),
        renderComponent: DateTime_RenderComponent,
        renderComponentResult: Label_RenderComponentResult,
        canContinuous: true
    },
    {
        kind: DiscreteIntervalsKind.time,
        columnHeader: 'Time',
        emptyMappedValue: getEmptyMappedValue_Time(),
        renderComponent: Time_RenderComponent,
        renderComponentResult: Label_RenderComponentResult,
        canContinuous: true
    },
    {
        kind: DiscreteIntervalsKind.boolean,
        columnHeader: 'Boolean',
        emptyMappedValue: getEmptyMappedValue_Boolean(),
        renderComponent: Boolean_RenderComponent,
        renderComponentResult: Label_RenderComponentResult,
        canContinuous: false
    }
];

class Interval extends React.Component<
    {
        kind: number; // DiscreteIntervalsKind
        i: number;
        left;
        next;
        right;
        step: number;
        type: string;
        canSplitInterval: boolean;
        label: string;
        themeObj: IValuesCollection;
        glob: IGlob;
        renderComponent?: RenderComponentType;
        onAddInterval?(): void;
        onChange?(value, index: number): void;
        onLabelChange?(value, index: number): void;
        onRemove?(index: number): void;
        onSplit?(index: number): void;
    },
    {}
> {
    //LL: 29.05.19: use for both i and r   'number'
    //LL: 27.05.19:  in NumberField,   also in other Fields must be ?  No, Date/Time prohibits
    //  emitErrorWhenBrokenMinMaxConstraints?: boolean;
    handleOnErrorBrokenMinMaxConstraints = (value) => {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value, this.props.i);
        }
    };

    handleOnDateChange = (value: string) => {
        if (this.props.onChange == null) {
            return;
        }

        if (value != null) {
            const valueParts = value.split(':');

            if (valueParts.length === 3) {
                // Make seconds be zero.
                value = valueParts[0] + ':' + valueParts[1] + ':00';
            }
        }

        this.props.onChange(value, this.props.i);
    };

    handleOnStringChange = (value: string) => {
        if (this.props.onChange == null) {
            return;
        }

        this.props.onChange(value, this.props.i);
    };

    handleOnNumberChange = (value: number) => {
        if (this.props.onChange == null) {
            return;
        }

        this.props.onChange(value, this.props.i);
    };

    handleLabelChange = (value) => {
        if (typeof this.props.onLabelChange === 'function') {
            this.props.onLabelChange(value, this.props.i);
        }
    };

    handleColorChange = (value) => {
        if (typeof this.props.onLabelChange === 'function') {
            this.props.onLabelChange(value, this.props.i);
        }
    };

    handleIconChange = (value) => {
        if (typeof this.props.onLabelChange === 'function') {
            this.props.onLabelChange(value, this.props.i);
        }
    };

    handleNumberChange = (value) => {
        if (typeof this.props.onLabelChange === 'function') {
            this.props.onLabelChange(value, this.props.i);
        }
    };

    handleBooleanChange = (value) => {
        if (typeof this.props.onLabelChange === 'function') {
            //LL: to bool is in closeButtonHandler
            this.props.onLabelChange(value, this.props.i);
            //LL: 10.05.23 BL try <SelectField returns string
            //LL: see in closeButtonHandler
            ////let bValue: boolean = value;
            //let bValue = value;
            //if (typeof value === 'string') {
            //    bValue = (value === 'true');
            //}
            //this.props.onLabelChange(bValue, this.props.i);
        }
    };

    handleDateChange = (value) => {
        //LL: our DateField returns:
        //    isDateTime => "2019-05-18T03:08:00", isDate => "2019-05-18"
        //LL: not always, so
        if (typeof value === 'number') {
            let D = new Date(value);
            const DateFormat =
                this.props.kind === DiscreteIntervalsKind.datetime ? 'yyyy-MM-ddTHH:mm:ss' : 'yyyy-MM-dd';
            value = Globalize.formatDate(D, { raw: DateFormat });
        }
        if (typeof this.props.onLabelChange === 'function') {
            this.props.onLabelChange(value, this.props.i);
        }
    };

    handleTimeChange = (value) => {
        //LL: convert to time-only:
        //const TimeValueFormat = DateTimeFunctions.TimeValueFormat;  // 'yyyy-MM-ddTHH:mm:ss'
        //const TimeDisplayFormat = DateTimeFunctions.TimeDisplayFormat; // 'HH:mm:ss'
        //const TimeDisplayFormatShort = DateTimeFunctions.TimeDisplayFormatShort;  // 'HH:mm'

        let t = Globalization.parseDate(value, { raw: TimeValueFormat });

        if (!Number.isNaN(t)) {
            //LL: 17.12.19: for Danish culture return 'HH.mm.ss', not 'HH:mm:ss'
            //value = Globalize.formatDate(t, { raw: TimeDisplayFormat });

            //LL: 17.12.19:  try:
            // http://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
            //       see Pattern fields and the Date Field Symbol Table
            // https://github.com/globalizejs/globalize/blob/master/doc/api/date/date-formatter.md
            //       see  { skeleton: "EHms" }	"Tue 17:55:00"
            value = Globalize('en').formatDate(t, { raw: TimeDisplayFormat });
        }

        if (typeof this.props.onLabelChange === 'function') {
            this.props.onLabelChange(value, this.props.i);
        }
    };

    handleRemove = (e) => {
        if (typeof this.props.onRemove === 'function') {
            this.props.onRemove(this.props.i);
        }
    };

    handleSplit = (e) => {
        if (typeof this.props.onSplit === 'function') {
            this.props.onSplit(this.props.i);
        }
    };

    getInput = (type, value) => {
        let leftConstr;
        let rightConstr;

        if (this.props.left !== -Infinity) {
            leftConstr = this.props.left;
        }

        if (this.props.next != null && this.props.next !== Infinity) {
            rightConstr = this.props.next;
        }

        if (DateTimeFunctions.isTypeOfDateOrDatetime(type)) {
            //LL: hideClearButton      needed ?  hideClearButton={ true }
            //LL: type = 'date' - for dxDateBox   It has also "datetime" !
            //LL: displayDateFormat or displayDateTimeFormat for displayFormat in dxDateBox,  (displayFormat: "EEEE, MMM dd",)
            //        "shortDate" is default for Date - "1/25/1970"
            //
            //LL:  dx-texteditor-input: padding: 7px 9px 8px;   set in sass:
            //        input.dx-texteditor-input
            //            padding-top: 1px
            //            padding-bottom: 1px
            //            padding-left: 1px

            //LL: was also hideTitle={ true }, rem by EU

            //LL: 05.06.19: to differ date and datetime, were the same
            let isDateTime = DateTimeFunctions.isTypeOfDatetime(type);
            let dFormat = getDateTimeValueFormat(type); // with or without time, now only without - temp

            //LL: rightConstr - 1
            if (rightConstr != null) {
                // "18-12-24"
                let d = Globalization.parseDate(rightConstr, { raw: dFormat });
                //LL: 05.06.19: to differ date and datetime, were the same:
                if (d == null && isDateTime) {
                    d = Globalization.parseDate(rightConstr, {
                        raw: DateValueFormat
                    });
                    if (d == null) {
                        d = Globalization.parseDate(rightConstr, {
                            raw: DateTimeValueFormatT
                        });
                    }
                }
                if (d != null) {
                    //d.setDate(d.getDate() - 1);
                    if (isDateTime) {
                        d.setSeconds(d.getSeconds() - 1);
                    } else {
                        d.setDate(d.getDate() - 1);
                    }
                    //rightConstr = Globalize.formatDate(d, { raw: dFormat });
                    rightConstr = Globalize('en').formatDate(d, { raw: dFormat }); //LL: 13.12.23: was error for Danish
                }
            }

            if (leftConstr != null) {
                // "18-12-24"
                let d2 = Globalization.parseDate(leftConstr, { raw: dFormat });
                //LL: 05.06.19: to differ date and datetime, were the same:
                if (d2 == null && isDateTime) {
                    d2 = Globalization.parseDate(leftConstr, {
                        raw: DateValueFormat
                    });
                    if (d2 == null) {
                        d2 = Globalization.parseDate(leftConstr, {
                            raw: DateTimeValueFormatT
                        });
                    }
                }
                if (d2 != null) {
                    //d2.setDate(d2.getDate() + 1);
                    if (isDateTime) {
                        d2.setSeconds(d2.getSeconds() + 1);
                    } else {
                        d2.setDate(d2.getDate() + 1);
                    }
                    //leftConstr = Globalize.formatDate(d2, { raw: dFormat });
                    leftConstr = Globalize('en').formatDate(d2, { raw: dFormat }); //LL: 13.12.23: was error for Danish
                }
            }

            let typeParam: string = 'date'; //  see  DateFieldTypes = 'date' | 'time' | 'datetime';
            let displayDateFormat = DateValueFormat;
            //LL: try, no, let always be "date" until Leo asks
            if (isDateTime) {
                typeParam = 'datetime';
                displayDateFormat = DateTimeValueFormat;
            }

            return (
                <DateField
                    value={this.props.right}
                    minDate={leftConstr}
                    maxDate={rightConstr}
                    type={typeParam}
                    displayDateFormat={displayDateFormat}
                    displayDateTimeFormat={displayDateFormat}
                    hideClearButton={true}
                    onChange={this.handleOnDateChange}
                />
            );
        } else if (DateTimeFunctions.isTypeOfTime(type)) {
            //let timeStepValue = this.props.step || timeStepDefault; // minutes
            let timeStepValue = this.props.step != null ? this.props.step : timeStepDefault; // minutes

            if (isNaN(timeStepValue)) {
                console.log("DiscreteIntervals: Error in Interval for 'time' in getInput: timeStepValue is wrong");
                return null;
            }

            if (rightConstr != null) {
                // "1899-12-31T02:30:00"
                let t = Globalization.parseDate(rightConstr, {
                    raw: TimeValueFormat
                });

                if (t != null) {
                    t.setSeconds(t.getSeconds() - 1);
                    //rightConstr = Globalize.formatDate(t, { raw: TimeValueFormat });
                    rightConstr = Globalize('en').formatDate(t, {
                        raw: TimeValueFormat
                    }); //LL: 17.12.19: was error for Danish
                }
            }

            if (leftConstr != null) {
                // "1899-12-31T02:30:00"
                let t2 = Globalization.parseDate(leftConstr, {
                    raw: TimeValueFormat
                });

                if (t2 != null) {
                    t2.setSeconds(t2.getSeconds() + 1);
                    //leftConstr = Globalize.formatDate(t2, { raw: TimeValueFormat });
                    leftConstr = Globalize('en').formatDate(t2, {
                        raw: TimeValueFormat
                    }); //LL: 17.12.19: was error for Danish
                }
            } else {
                //  because of <=
                let t2 = getMinTimeDate();
                t2.setSeconds(t2.getSeconds() + 1);
                //leftConstr = Globalize.formatDate(t2, { raw: TimeValueFormat });
                leftConstr = Globalize('en').formatDate(t2, {
                    raw: TimeValueFormat
                }); //LL: 17.12.19: was error for Danish
            }

            return (
                <DateField
                    type={'time'}
                    value={this.props.right}
                    minDate={leftConstr}
                    maxDate={rightConstr}
                    displayDateTimeFormat={TimeDisplayFormat}
                    hideClearButton={true}
                    intervalMinutes={timeStepValue}
                    options={{ formattedTime: true }}
                    onChange={this.handleOnDateChange}
                />
            );
        } else {
            let restoreOnApplyIfBrokenMinMaxConstraints = false; //LL: 29.05.19: for Leo

            switch (type) {
                case ATTRIBUTE_TYPES.STRING:
                case 'string':
                    return (
                        <StringField
                            value={this.props.right}
                            changeOnBlurOnly={true}
                            applyOnEnter={true}
                            onChange={this.handleOnStringChange}
                        />
                    );

                case ATTRIBUTE_TYPES.INTEGER:
                    return (
                        <NumberField
                            value={this.props.right}
                            min={leftConstr}
                            max={rightConstr}
                            minConstraintAllowEqual={false}
                            maxConstraintAllowEqual={false}
                            applyOnEnter={true}
                            showBrokenMinMaxConstraints={true}
                            restoreOnApplyIfBrokenMinMaxConstraints={restoreOnApplyIfBrokenMinMaxConstraints}
                            emitErrorWhenBrokenMinMaxConstraints={true}
                            onErrorBrokenMinMaxConstraints={this.handleOnErrorBrokenMinMaxConstraints}
                            onChange={this.handleOnNumberChange}
                        />
                    );

                case ATTRIBUTE_TYPES.REAL:
                case 'number':
                    return (
                        <NumberField
                            value={this.props.right}
                            integer={false}
                            min={leftConstr}
                            max={rightConstr}
                            minConstraintAllowEqual={false}
                            maxConstraintAllowEqual={false}
                            applyOnEnter={true}
                            showBrokenMinMaxConstraints={true}
                            restoreOnApplyIfBrokenMinMaxConstraints={restoreOnApplyIfBrokenMinMaxConstraints}
                            emitErrorWhenBrokenMinMaxConstraints={true}
                            onErrorBrokenMinMaxConstraints={this.handleOnErrorBrokenMinMaxConstraints}
                            onChange={this.handleOnNumberChange}
                        />
                    );
            }
        }
    };

    render() {
        let isHeader = this.props.i === -1;
        let isNullValueElement = this.props.i === -2;
        let isTrueValueElement = this.props.i === -3;
        let isFalseValueElement = this.props.i === -4;
        let isBoolValueElement = isTrueValueElement || isFalseValueElement;
        let isOrdinary = !isHeader && !isNullValueElement && !isBoolValueElement;
        let left;

        if (isOrdinary) {
            if (this.props.left === -Infinity) {
                left = '-\u221E';
                //LL: Time has no infinity
                if (this.props.type === 'time') {
                    left = timeInfinityMinus;
                }
            } else {
                //LL: our DateField returns:
                //    isDateTime => "2019-05-18T03:08:00", isDate => "2019-05-18"      use this.props.type
                let leftValue = this.props.left;

                if (this.props.type === 'time') {
                    leftValue = convertTimeValueAsDateToString(leftValue);
                }

                if (this.props.type === 'datetime') {
                    let dt = Date.parse(leftValue);

                    if (!isNaN(dt)) {
                        let d = new Date(dt);
                        leftValue = Globalize.formatDate(d, {
                            raw: DateTimeValueFormat
                        });
                    }
                }

                left = (
                    <input className="form-control" type="text" disabled={true} value={leftValue} title={leftValue} />
                );
            }
        } else {
            left = <label>{this.props.left}</label>;
        }

        let rightElement: React.JSX.Element;

        if (isOrdinary) {
            if (this.props.right === Infinity) {
                //LL: Time has no infinity
                let infinityStr = '\u221E';

                if (this.props.type === 'time') {
                    infinityStr = timeInfinity;
                }

                //LL: 24.06.19:
                //   Sometimes new Interval cannot be added (for "time", for "dates" with very big "step"),
                //   So, addInterval should be disabled - same way as the last "plus" ("split") button
                //      getSplit for last interval = getNext
                let disabledClass = '';
                let addOnClick = this.props.onAddInterval;

                if (!this.props.canSplitInterval) {
                    disabledClass = ' disabled';
                    addOnClick = null;
                }

                rightElement = (
                    <div className="margin" onClick={addOnClick}>
                        <span className={'glyphicon glyphicon-pencil' + disabledClass}></span>
                        <em>{infinityStr}</em>
                    </div>
                );
            } else {
                rightElement = this.getInput(this.props.type, this.props.right);
            }
        } else {
            rightElement = <label>{this.props.right}</label>;
        }

        let center;
        let centerClass = 'center';

        if (!isHeader) {
            //LL: comment to initial Interval  (-Infinity  Infinity):
            //LL: 07.06.19: see also comment in DiscreteIntervals.processChange !!!
            //   this.props.label may be defined here (i.e. not null), when Intervals were created and afterwards all removed
            //LL: what to do with this last label when there are no values ?
            //    1. we can set values and labels to null in parent normalization
            //    2. or use this last label (color) for full Interval (-Infinity, +Infinity)

            let isInfinityInterval = this.props.left === -Infinity && this.props.right === Infinity;

            //let allowNull = isNullValueElement;
            //LL: 26.10.21: isBoolValueElement
            let allowNull = isNullValueElement || isBoolValueElement;

            switch (this.props.kind) {
                case DiscreteIntervalsKind.label:
                    const options: IDiscreteIntervalsKindRenderComponentOptions = { disabled: isInfinityInterval };

                    let label: string;
                    let onChangeFunc;

                    if (!isInfinityInterval) {
                        let placeholderValue = getIntervalPlaceholderValue(
                            this.props.left,
                            this.props.right,
                            this.props.type,
                            true
                        );

                        if (isNullValueElement) {
                            placeholderValue = '';
                        }

                        options.placeholder = placeholderValue;
                        label = this.props.label;
                        onChangeFunc = this.handleLabelChange;
                    } else {
                        label = 'Default interval';
                    }

                    center = (
                        <this.props.renderComponent
                            value={label}
                            allowNull={allowNull}
                            options={options}
                            glob={this.props.glob}
                            onChange={onChangeFunc}
                        />
                    );
                    break;

                case DiscreteIntervalsKind.color:
                    center = (
                        <this.props.renderComponent
                            value={this.props.label}
                            options={{ allowTransparency: true }}
                            allowNull={allowNull}
                            themeObj={this.props.themeObj}
                            glob={this.props.glob}
                            onChange={this.handleColorChange}
                        />
                    );
                    break;

                case DiscreteIntervalsKind.icon:
                    center = (
                        <this.props.renderComponent
                            value={this.props.label}
                            allowNull={allowNull}
                            glob={this.props.glob}
                            onChange={this.handleIconChange}
                        />
                    );
                    break;

                case DiscreteIntervalsKind.number:
                case DiscreteIntervalsKind.real:
                case DiscreteIntervalsKind.integer:
                    center = (
                        <this.props.renderComponent
                            value={this.props.label}
                            allowNull={allowNull}
                            onChange={this.handleNumberChange}
                            glob={this.props.glob}
                        />
                    );
                    break;

                case DiscreteIntervalsKind.boolean:
                    center = (
                        <this.props.renderComponent
                            value={this.props.label}
                            allowNull={allowNull}
                            onChange={this.handleBooleanChange}
                            glob={this.props.glob}
                        />
                    );
                    break;

                case DiscreteIntervalsKind.date:
                case DiscreteIntervalsKind.datetime: //DateTime_RenderComponent
                    let optionsDate: any = {
                        isDateTime: this.props.kind === DiscreteIntervalsKind.datetime
                    };
                    center = (
                        <this.props.renderComponent
                            value={this.props.label}
                            allowNull={allowNull}
                            onChange={this.handleDateChange}
                            options={optionsDate}
                            glob={this.props.glob}
                        />
                    );
                    break;

                case DiscreteIntervalsKind.time: // Time_RenderComponent
                    center = (
                        <this.props.renderComponent
                            value={this.props.label}
                            allowNull={allowNull}
                            onChange={this.handleTimeChange}
                            glob={this.props.glob}
                        />
                    );
                    break;
            }
        } else {
            //  isHeader
            center = <label style={{ paddingTop: '4px' }}>{this.props.label}</label>;
            centerClass += ' ' + 'colHeader';
        }

        let leftRelationSign;
        let rightRelationSign;
        let removeButton;
        let splitButton;

        if (isOrdinary) {
            if (this.props.i === 0) {
                leftRelationSign = '\u003C'; //  <
                //LL:  Time has no infinity
                if (this.props.type === 'time') {
                    leftRelationSign = '\u2264'; // <=
                }
            } else {
                leftRelationSign = '\u2264';
            }

            rightRelationSign = '\u003C'; //&#60;

            if (this.props.left !== -Infinity || this.props.right !== Infinity) {
                removeButton = (
                    <div className="remove" onClick={this.handleRemove}>
                        <span className="glyphicon glyphicon-remove"></span>
                    </div>
                );
            }

            //LL: 27.05.19: "canSplit" also for "empty" intervals (both Margins are Infinity)
            //LL: Leo wants not "split", but "insert". I.e. interpretation as Sequence of Values, not Math Intervals
            //if ((this.props.left !== -Infinity) || (this.props.right !== Infinity)) {
            let splitClass = 'insert'; // yes
            let splitSpanClass = 'glyphicon glyphicon-plus';
            let splitTitle = 'insert Separating Value between "From" and "To"';
            let splitOnClick = this.handleSplit;

            if (!this.props.canSplitInterval) {
                splitSpanClass += ' disabled';
                splitTitle = 'cannot insert';
                splitOnClick = null;
            }

            splitButton = (
                <div className={splitClass} onClick={splitOnClick} title={splitTitle}>
                    <span className={splitSpanClass}></span>
                </div>
            );
            //}
        }
        //LL: 26.10.21: isBoolValueElement
        //else if (isNullValueElement) {
        else if (isNullValueElement || isBoolValueElement) {
            //leftRelationSign = '\u21d2';  // =>
            leftRelationSign = '\u2794'; // -> bold
            //  http://www.fileformat.info/info/unicode/char/search.htm?q=arrow&preview=entity
            //  U+21C9	RIGHTWARDS PAIRED ARROWS
            //  U+21A0	RIGHTWARDS TWO HEADED ARROW
            //  U+2192	RIGHTWARDS ARROW

            //  only try:
            //rightRelationSign = '\u2192';  // ->

            //  -- removeButton
            //LL: disabled, if value is null
            let removeSpanClass = 'glyphicon glyphicon-remove';
            let removeTitle = 'Clear Assigned value'; // "Unset Mapped value"
            let removeOnClick = this.handleRemove;

            if (this.props.label == null) {
                removeSpanClass += ' disabled';
                removeTitle = 'Mapping value is not assigned';
                removeOnClick = null;
            }
            //  title="Unset Mapped value"
            //removeButton = (
            //    <div className="remove"
            //         onClick={ this.handleRemove }
            //         title="Clear Assigned value"
            //    >
            //        <span className="glyphicon glyphicon-remove">
            //        </span>
            //    </div>
            //);
            removeButton = (
                <div className="remove" onClick={removeOnClick} title={removeTitle}>
                    <span className={removeSpanClass}></span>
                </div>
            );
        }

        return (
            <div className="interval">
                {removeButton}
                {splitButton}

                <div className="left">
                    <div className="value">{left}</div>
                    <div className="sign">{leftRelationSign}</div>
                </div>

                <div className={centerClass}>{center}</div>

                <div className="right">
                    <div className="sign">{rightRelationSign}</div>
                    <div className="value">{rightElement}</div>
                </div>
            </div>
        );
    }
}

class Interval2 extends React.Component<
    {
        kind: number;
        i: number;
        prev;
        next;
        step: number;
        separatingValue;
        type;
        label: string;
        noLabel?: boolean;
        canSplitInterval: boolean;
        renderComponent?: React.JSX.ElementType;
        glob: IGlob;

        onAddInterval?(): void;
        onChange?(value, index: number): void;
        onLabelChange?(value, index: number): void;
        onRemove?(index: number): void;
        onSplit?(index: number): void;
    },
    {}
> {
    addInterval = () => {
        if (typeof this.props.onAddInterval === 'function') {
            this.props.onAddInterval();
        }
    };

    handleOnErrorBrokenMinMaxConstraints = (value) => {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value, this.props.i);
        }
    };

    handleChange = (value) => {
        //LL: our DateField returns:
        //    isDateTime => "2019-05-18T03:08:00", isDate => "2019-05-18"      use this.props.type
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value, this.props.i);
        }
    };

    handleLabelChange = (value) => {
        if (typeof this.props.onLabelChange === 'function') {
            this.props.onLabelChange(value, this.props.i);
        }
    };

    //LL:  = handleLabelChange
    handleColorChange = (value) => {
        if (typeof this.props.onLabelChange === 'function') {
            this.props.onLabelChange(value, this.props.i);
        }
    };

    //LL:  = handleLabelChange
    handleIconChange = (value) => {
        if (typeof this.props.onLabelChange === 'function') {
            this.props.onLabelChange(value, this.props.i);
        }
    };

    //LL:  = handleLabelChange
    handleNumberChange = (value) => {
        if (typeof this.props.onLabelChange === 'function') {
            this.props.onLabelChange(value, this.props.i);
        }
    };

    handleDateChange = (value) => {
        //LL: our DateField returns:
        //    isDateTime => "2019-05-18T03:08:00", isDate => "2019-05-18"
        //LL: not always, so
        if (typeof value === 'number') {
            let D = new Date(value);
            const DateFormat =
                this.props.kind === DiscreteIntervalsKind.datetime ? 'yyyy-MM-ddTHH:mm:ss' : 'yyyy-MM-dd';
            value = Globalize.formatDate(D, { raw: DateFormat });
        }
        if (typeof this.props.onLabelChange === 'function') {
            this.props.onLabelChange(value, this.props.i);
        }
    };

    handleTimeChange = (value) => {
        //LL: convert to time-only:
        //const TimeValueFormat = DateTimeFunctions.TimeValueFormat;  // 'yyyy-MM-ddTHH:mm:ss'
        //const TimeDisplayFormat = DateTimeFunctions.TimeDisplayFormat; // 'HH:mm:ss'
        //const TimeDisplayFormatShort = DateTimeFunctions.TimeDisplayFormatShort;  // 'HH:mm'
        let t = Globalization.parseDate(value, { raw: TimeValueFormat });

        if (!Number.isNaN(t)) {
            //value = Globalize.formatDate(t, { raw: TimeDisplayFormat });
            value = Globalize('en').formatDate(t, { raw: TimeDisplayFormat }); //LL: 17.12.19: for Danish err
        }

        if (typeof this.props.onLabelChange === 'function') {
            this.props.onLabelChange(value, this.props.i);
        }
    };

    handleRemove = (e) => {
        if (typeof this.props.onRemove === 'function') {
            this.props.onRemove(this.props.i);
        }
    };

    handleSplit = (e) => {
        if (typeof this.props.onSplit === 'function') {
            this.props.onSplit(this.props.i);
        }
    };

    getInput = (type, value) => {
        let leftConstr;
        let rightConstr;

        if (this.props.prev !== -Infinity) {
            leftConstr = this.props.prev;
        }

        if (this.props.next != null && this.props.next !== Infinity) {
            rightConstr = this.props.next;
        }

        if (DateTimeFunctions.isTypeOfDateOrDatetime(type)) {
            //LL: hideClearButton      needed ?  hideClearButton={ true }
            //LL: type = 'date' - for dxDateBox   It has also "datetime" !
            //LL: displayDateFormat or displayDateTimeFormat for displayFormat in dxDateBox,  (displayFormat: "EEEE, MMM dd",)
            //        "shortDate" is default for Date - "1/25/1970"
            //
            //LL:  dx-texteditor-input: padding: 7px 9px 8px;   set in sass:
            //        input.dx-texteditor-input
            //            padding-top: 1px
            //            padding-bottom: 1px
            //            padding-left: 1px

            //LL: 05.06.19: to differ date and datetime, were the same
            let isDateTime = DateTimeFunctions.isTypeOfDatetime(type);
            let dFormat = getDateTimeValueFormat(type); // with or without time, now only without - temp

            //LL: rightConstr - 1
            if (rightConstr != null) {
                // "18-12-24"
                let d = Globalization.parseDate(rightConstr, { raw: dFormat });
                //LL: 05.06.19: to differ date and datetime, were the same:
                if (d == null && isDateTime) {
                    d = Globalization.parseDate(rightConstr, {
                        raw: DateValueFormat
                    });
                    if (d == null) {
                        d = Globalization.parseDate(rightConstr, {
                            raw: DateTimeValueFormatT
                        });
                    }
                }

                if (d != null) {
                    //d.setDate(d.getDate() - 1);
                    if (isDateTime) {
                        d.setSeconds(d.getSeconds() - 1);
                    } else {
                        d.setDate(d.getDate() - 1);
                    }
                    rightConstr = Globalize.formatDate(d, { raw: dFormat });
                }
            }

            if (leftConstr != null) {
                // "18-12-24"
                let d2 = Globalization.parseDate(leftConstr, { raw: dFormat });
                //LL: 05.06.19: to differ date and datetime, were the same:
                if (d2 == null && isDateTime) {
                    d2 = Globalization.parseDate(leftConstr, {
                        raw: DateValueFormat
                    });
                    if (d2 == null) {
                        d2 = Globalization.parseDate(leftConstr, {
                            raw: DateTimeValueFormatT
                        });
                    }
                }
                if (d2 != null) {
                    //d2.setDate(d2.getDate() + 1);
                    if (isDateTime) {
                        d2.setSeconds(d2.getSeconds() + 1);
                    } else {
                        d2.setDate(d2.getDate() + 1);
                    }
                    leftConstr = Globalize.formatDate(d2, { raw: dFormat });
                }
            }

            let typeParam: any = 'date'; //  see  DateFieldTypes = 'date' | 'time' | 'datetime';
            let displayDateFormat = DateValueFormat;
            //LL: try, no, let always be "date" until Leo asks
            if (isDateTime) {
                typeParam = 'datetime';
                displayDateFormat = DateTimeValueFormat;
            }

            return (
                <DateField
                    type={typeParam}
                    value={value}
                    minDate={leftConstr}
                    maxDate={rightConstr}
                    displayDateFormat={displayDateFormat}
                    displayDateTimeFormat={displayDateFormat}
                    hideClearButton={true}
                    onChange={this.handleChange}
                />
            );
        } else if (DateTimeFunctions.isTypeOfTime(type)) {
            let timeStepValue = this.props.step != null ? this.props.step : timeStepDefault; // minutes
            if (isNaN(timeStepValue)) {
                console.log("DiscreteIntervals: Error in Interval for 'time' in getInput: timeStepValue is wrong");
                return null;
            }

            if (rightConstr != null) {
                // "1899-12-31T02:30:00"
                let t = Globalization.parseDate(rightConstr, {
                    raw: TimeValueFormat
                });
                if (t != null) {
                    t.setSeconds(t.getSeconds() - 1);
                    //rightConstr = Globalize.formatDate(t, { raw: TimeValueFormat });
                    rightConstr = Globalize('en').formatDate(t, {
                        raw: TimeValueFormat
                    }); //LL: 17.12.19: was error for Danish
                }
            }

            if (leftConstr != null) {
                // "1899-12-31T02:30:00"
                let t2 = Globalization.parseDate(leftConstr, {
                    raw: TimeValueFormat
                });

                if (t2 != null) {
                    t2.setSeconds(t2.getSeconds() + 1);
                    //leftConstr = Globalize.formatDate(t2, { raw: TimeValueFormat });
                    leftConstr = Globalize('en').formatDate(t2, {
                        raw: TimeValueFormat
                    }); //LL: 17.12.19: was error for Danish
                }
            } else {
                //  because of <=
                let t2 = getMinTimeDate();
                t2.setSeconds(t2.getSeconds() + 1);
                //leftConstr = Globalize.formatDate(t2, { raw: TimeValueFormat });
                leftConstr = Globalize('en').formatDate(t2, {
                    raw: TimeValueFormat
                }); //LL: 17.12.19: was error for Danish
            }

            // LL: 13.12.18: pickerTypeForTime  'list' or 'rollers' (default in DateField)
            //     pickerTypeForTime={ 'list' }

            // LL: 13.12.18:  see same in ChartAxisField.tsx
            //LL: 09.11.18: in DateField.tsx change in normalizeValue by RYB on 31.10.18 and it breaks my Chart code for "time"
            //LL: 09.11.18: to avoid it, introduce option "formattedTime = true"
            return (
                <DateField
                    type={'time'}
                    value={value}
                    minDate={leftConstr}
                    maxDate={rightConstr}
                    displayDateTimeFormat={TimeDisplayFormat}
                    hideClearButton={true}
                    intervalMinutes={timeStepValue}
                    options={{ formattedTime: true }}
                    onChange={this.handleChange}
                />
            );
        } else {
            //LL:  new:  showBrokenMinMaxConstraints, default False
            //LL: 16.01.19:  new:  restoreOnApplyIfBrokenMinMaxConstraints, default False

            //let restoreOnApplyIfBrokenMinMaxConstraints = true;  //  was
            let restoreOnApplyIfBrokenMinMaxConstraints = false; //LL: 29.05.19: for Leo

            switch (type) {
                case 's':
                case 'string':
                    return <StringField value={value} changeOnBlurOnly={true} onChange={this.handleChange} />;

                case 'i':
                    return (
                        <NumberField
                            value={value}
                            onChange={this.handleChange}
                            min={leftConstr}
                            max={rightConstr}
                            minConstraintAllowEqual={false}
                            maxConstraintAllowEqual={false}
                            applyOnEnter={true}
                            showBrokenMinMaxConstraints={true}
                            restoreOnApplyIfBrokenMinMaxConstraints={restoreOnApplyIfBrokenMinMaxConstraints}
                            emitErrorWhenBrokenMinMaxConstraints={true}
                            onErrorBrokenMinMaxConstraints={this.handleOnErrorBrokenMinMaxConstraints}
                        />
                    );

                case 'r':
                case 'number':
                    return (
                        <NumberField
                            value={value}
                            onChange={this.handleChange}
                            integer={false}
                            min={leftConstr}
                            max={rightConstr}
                            minConstraintAllowEqual={false}
                            maxConstraintAllowEqual={false}
                            applyOnEnter={true}
                            showBrokenMinMaxConstraints={true}
                            restoreOnApplyIfBrokenMinMaxConstraints={restoreOnApplyIfBrokenMinMaxConstraints}
                            emitErrorWhenBrokenMinMaxConstraints={true}
                            onErrorBrokenMinMaxConstraints={this.handleOnErrorBrokenMinMaxConstraints}
                        />
                    );
            }
        }
    };

    render() {
        let isHeader = this.props.i === -1;

        // Interval2 render
        //LL: new: use "separatingValue" = this.props.left, but editable as "right"
        //  see:
        //separatingValue={ value.values[i] }
        //next={ value.values[i + 1] }
        //prev={ i === 0 ? null : value.values[i - 1] }

        let separatingValue;

        if (!isHeader) {
            if (this.props.separatingValue === -Infinity) {
                //separatingValue = '-\u221E';
                ////LL: Time has no infinity
                //if (this.props.type === 'time') {
                //    separatingValue = timeInfinityMinus;
                //}

                //LL:  "grayed" minus Infinity:

                let infinityStr = '-\u221E';
                //LL: Time has no infinity
                if (this.props.type === 'time') {
                    infinityStr = timeInfinityMinus;
                }

                separatingValue = <StringField value={infinityStr} readOnly={true} />;
            } else if (this.props.separatingValue === Infinity) {
                //LL: Time has no infinity
                let infinityStr = '\u221E';
                if (this.props.type === 'time') {
                    infinityStr = timeInfinity;
                }

                ////LL: 24.06.19:
                ////   Sometimes new Interval cannot be added (for "time", for "dates" with very big "step"),
                ////   So, addInterval should be disabled - same way as the last "plus" ("split") button
                ////      getSplit for last interval = getNext
                //let disabledClass = "";
                //let addOnClick = this.addInterval;
                //if (!this.props.canSplitInterval) {
                //    disabledClass = " disabled";
                //    addOnClick = null;
                //}
                //
                //separatingValue = (
                //    <div
                //        className="margin"
                //        onClick={ addOnClick }
                //    >
                //        <span className={ "glyphicon glyphicon-pencil" + disabledClass }>
                //        </span>
                //        <em>
                //            { infinityStr }
                //        </em>
                //    </div>
                //);

                //LL: without "pencil":
                //LL:  "grayed" plus Infinity:
                separatingValue = <StringField value={infinityStr} readOnly={true} />;
            } else {
                separatingValue = this.getInput(this.props.type, this.props.separatingValue);
            }
        } else {
            separatingValue = <label>{this.props.separatingValue}</label>;
        }

        let center;
        let centerClass = 'center';

        let useRelationSigns = true; //LL: my flag, when class intervals-container-layout-separatingValues-vert
        let leftRelationSign;
        let rightRelationSign;

        if (this.props.noLabel !== true) {
            if (!isHeader) {
                if (useRelationSigns) {
                    if (this.props.i === 0) {
                        leftRelationSign = '\u003C'; //  <
                        //LL:  Time has no infinity
                        if (this.props.type === 'time') {
                            leftRelationSign = '\u2264'; // <=
                        }
                    } else {
                        leftRelationSign = '\u2264';
                    }

                    rightRelationSign = '\u003C'; //&#60;
                }

                //LL: comment to initial Interval  (-Infinity  Infinity):
                //LL: 07.06.19: see also comment in DiscreteIntervals.processChange !!!
                //   this.props.label may be defined here (i.e. not null), when Intervals were created and afterwards all removed
                //LL: what to do with this last label when there are no values ?
                //    1. we can set values and labels to null in parent normalization
                //    2. or use this last label (color) for full Interval (-Infinity, +Infinity)

                let isInfinityInterval = this.props.separatingValue === -Infinity && this.props.next === Infinity;

                switch (this.props.kind) {
                    case DiscreteIntervalsKind.label:
                        let label;
                        let onChangeFunc;
                        let options: any = { disabled: isInfinityInterval };
                        if (!isInfinityInterval) {
                            let placeholderValue = getIntervalPlaceholderValue(
                                this.props.separatingValue,
                                this.props.next,
                                this.props.type,
                                true
                            );
                            options.placeholder = placeholderValue;
                            label = this.props.label;
                            onChangeFunc = this.handleLabelChange;
                        } else {
                            label = 'Default interval';
                        }

                        center = (
                            <this.props.renderComponent
                                value={label}
                                options={options}
                                glob={this.props.glob}
                                onChange={onChangeFunc}
                            />
                        );
                        break;

                    case DiscreteIntervalsKind.color:
                        //LL: 01.07.19
                        //LL: see in gantt.tsx:  <this.props.barComponent
                        //let renderComponent: React.ComponentClass<any> = Color_RenderComponent;

                        //LL: 03.08.20: try, but let be always allow - as in <Interval>
                        let optionsColor: any = { allowTransparency: true };
                        //let optionsColor: any;
                        //if (this.props.allowColorTransparency != null) {
                        //    optionsColor = { allowTransparency: this.props.allowColorTransparency };
                        //}

                        center = (
                            <this.props.renderComponent
                                value={this.props.label}
                                options={optionsColor}
                                onChange={this.handleColorChange}
                                glob={this.props.glob}
                            />
                        );
                        break;

                    case DiscreteIntervalsKind.icon:
                        center = (
                            <this.props.renderComponent
                                value={this.props.label}
                                onChange={this.handleIconChange}
                                glob={this.props.glob}
                            />
                        );
                        break;

                    case DiscreteIntervalsKind.number:
                    case DiscreteIntervalsKind.real:
                    case DiscreteIntervalsKind.integer:
                        center = (
                            <this.props.renderComponent
                                value={this.props.label}
                                onChange={this.handleNumberChange}
                                glob={this.props.glob}
                            />
                        );
                        break;

                    case DiscreteIntervalsKind.date:
                    case DiscreteIntervalsKind.datetime:
                        let optionsDate: any = {
                            isDateTime: this.props.kind === DiscreteIntervalsKind.datetime
                        };
                        center = (
                            <this.props.renderComponent
                                value={this.props.label}
                                onChange={this.handleDateChange}
                                options={optionsDate}
                                glob={this.props.glob}
                            />
                        );
                        break;

                    case DiscreteIntervalsKind.time:
                        center = (
                            <this.props.renderComponent
                                value={this.props.label}
                                onChange={this.handleTimeChange}
                                glob={this.props.glob}
                            />
                        );
                        break;
                }
            } else {
                //  isHeader
                //center = (
                //    <label style={ { paddingTop: "4px" } }>
                //        { this.props.label }
                //    </label>
                //);
                center = <label>{this.props.label}</label>;

                //LL: try, no
                //center = (
                //    <div className="form-control">
                //        <label style={ { paddingTop: "4px" } }>
                //            { this.props.label }
                //        </label>
                //    </div>
                //);

                centerClass += ' ' + 'colHeader';
            }
        }

        let removeButton;
        let splitButton;

        if (!isHeader) {
            if (!(this.props.separatingValue === -Infinity || this.props.separatingValue === Infinity)) {
                removeButton = (
                    <div className="remove" onClick={this.handleRemove} title={'remove Separating Value'}>
                        <span className="glyphicon glyphicon-remove"></span>
                    </div>
                );
            }

            //LL: 27.05.19: "canSplit" also for "empty" intervals (both Margins are Infinity)
            //LL: Leo wants not "split", but "insert". I.e. interpretation as Sequence of Values, not Math Intervals
            //if ((this.props.left !== -Infinity) || (this.props.right !== Infinity)) {
            let splitClass = 'insert'; // yes
            let splitSpanClass = 'glyphicon glyphicon-plus';
            let splitTitle = 'insert Separating Value between "current" and "next"';
            let splitOnClick = this.handleSplit;

            if (!this.props.canSplitInterval) {
                splitSpanClass += ' disabled';
                splitTitle = 'cannot insert';
                splitOnClick = null;
            }

            splitButton = (
                <div className={splitClass} onClick={splitOnClick} title={splitTitle}>
                    <span className={splitSpanClass}></span>
                </div>
            );
            //}
        }

        //LL: for intervals2:

        let classNameValue = 'value value-container';
        if (isHeader) {
            classNameValue += ' value-container-header';
        }

        let classNameResult = 'result';
        if (isHeader) {
            //classNameResult += " result-colHeader";
            classNameResult = 'result-colHeader';
        }

        let resultElem;
        if (this.props.noLabel !== true) {
            resultElem = (
                <div className={classNameResult}>
                    <div className={centerClass}>{center}</div>
                </div>
            );

            //  try:
            if (useRelationSigns && !isHeader) {
                classNameResult += ' with-RelationSigns';
                centerClass += ' center-flexItem';

                resultElem = (
                    <div className={classNameResult}>
                        <div className="sign">{leftRelationSign}</div>
                        <div className={centerClass}>{center}</div>
                        <div className="sign">{rightRelationSign}</div>
                    </div>
                );
            }
        }

        return (
            <React.Fragment>
                <div className="from">
                    <div className="remove-container">{removeButton}</div>
                    <div className="remove-container">{splitButton}</div>
                    <div className={classNameValue}>{separatingValue}</div>
                </div>
                {resultElem}
            </React.Fragment>
        );
    }
}

export class DiscreteIntervals extends React.Component<
    {
        value;
        type: string; // = data type
        kind: DiscreteIntervalsKind; // string | color   ( | image )
        useNullValueMapping?: boolean; //LL: 14.11.19: used in IntervalsSelect.tsx with "false"
        themeObj?: IValuesCollection;
        allowColorFunctionsFlag?: boolean;
        glob: IGlob;
        onChange(value, hasIntervalError?): void;
    },
    {}
> {
    private static iOrder(a, b) {
        return a < b;
    }

    private static sOrder(a, b) {
        return a < b;
    }

    private static dOrder(a, b) {
        a = Globalization.parseDate(a, { raw: DateValueFormat });
        b = Globalization.parseDate(b, { raw: DateValueFormat });
        return a < b;
    }

    private static dtOrder(a, b) {
        //LL: 05.06.19
        //LL: our DateField returns:
        //    isDateTime (new) => "2019-05-18T03:08:00", isDate (old) => "2019-05-18"
        let a2: any = Globalization.parseDate(a, { raw: DateValueFormat });

        if (a2 == null) {
            a2 = Globalization.parseDate(a, { raw: DateTimeValueFormatT });
        }

        if (a2 == null) {
            a2 = Date.parse(a); // returns not Date object, but number of milliseconds
        }

        let b2: any = Globalization.parseDate(b, { raw: DateValueFormat });

        if (b2 == null) {
            b2 = Globalization.parseDate(b, { raw: DateTimeValueFormatT });
        }

        if (b2 == null) {
            b2 = Date.parse(b);
        }

        return a2 < b2;
    }

    private static tOrder(a, b) {
        a = Globalization.parseDate(a, { raw: TimeValueFormat });
        b = Globalization.parseDate(b, { raw: TimeValueFormat });
        return a < b;
    }

    private static getOrderFunction(aType) {
        let innerOrder;
        switch (aType) {
            case 's':
            case 'string':
                innerOrder = DiscreteIntervals.sOrder;
                break;
            case 'i':
            case 'r':
            case 'number':
                innerOrder = DiscreteIntervals.iOrder;
                break;
            case 'date':
                innerOrder = DiscreteIntervals.dOrder;
                break;
            case 'datetime':
                innerOrder = DiscreteIntervals.dtOrder;
                break;
            case 'time':
                innerOrder = DiscreteIntervals.tOrder;
                break;
            default:
                return null;
        }

        return function (a, b) {
            if (a === -Infinity || b === Infinity) {
                return true;
            }
            if (a === Infinity || b === -Infinity) {
                return false;
            }
            return innerOrder(a, b);
        };
    }

    public static validateDiscreteIntervals(value, aType) {
        if (value == null) {
            return true;
        }

        let values = value.values; //  values are without Infinities when called externally, with Infinities when inside

        if (values == null || values.length === 0) {
            return true;
        }

        let orderFunc = DiscreteIntervals.getOrderFunction(aType);
        if (orderFunc == null) {
            return true;
        }

        // slice: Если индекс отрицательный, end указывает смещение от конца последовательности.
        // slice(2, -1) извлечёт из последовательности элементы начиная с третьего элемента с начала и заканчивая вторым с конца.
        let find = _.find(values.slice(0, -1), function (value, i) {
            let next = values[i + 1];
            return orderFunc(value, next) === false;
        });

        return find == null;
    }

    private static getSortFunction(aType) {
        let orderFunc = DiscreteIntervals.getOrderFunction(aType);

        return function (a, b) {
            if (a.value === -Infinity || b.value === Infinity) {
                return -1;
            }
            if (a.value === Infinity || b.value === -Infinity) {
                return 1;
            }

            if (a.value !== Infinity && b.value === Infinity) {
                return -1;
            }
            if (a.value === Infinity && b.value !== Infinity) {
                return 1;
            }

            //return (a.value - b.value);  //  temp, for numbers

            let order = orderFunc(a.value, b.value); // a<b
            if (order) {
                return -1;
            } else {
                return 1;
            }
        };
    }

    //LL: 03.06.19: to call when wrong order
    private static sortDiscreteIntervals(value, aType) {
        if (value == null) {
            return null;
        }
        if (value.values == null || value.values.length === 0) {
            return null;
        }

        // 1) value.values with Infinities, so labels.len < values.len   -- better to save labels
        // 2) value.values without Infinities, so labels.len > values.len  -- add Infinity

        // 1)
        //let sorted = _.map(
        //    value.labels,
        //    (label, i) => {
        //        return {label: label, value: value.values[i + 1]};  //  "right" val
        //    });

        // 2)
        let N = value.values.length; // = labels.len - 1
        let sorted = _.map(value.labels, (label, i) => {
            return { label: label, value: i < N ? value.values[i] : Infinity };
        });

        let sortFunc = DiscreteIntervals.getSortFunction(aType);

        sorted = sorted.sort(sortFunc);

        let newVal: any = { labels: [], values: [] };

        _.each(sorted, (obj, i) => {
            newVal.labels.push(obj.label);
            if (i < N) {
                newVal.values.push(obj.value);
            }
        });

        if (value.step != null) {
            newVal.step = value.step;
        }
        if (value.precision != null) {
            newVal.precision = value.precision;
        }
        //LL: 14.11.19: nullMappedValue
        if (value.nullMappedValue != null) {
            newVal.nullMappedValue = value.nullMappedValue;
        }

        return newVal;
    }

    //LL: 29.08.19: my flag:  2 columns: "Separating Value" and ~~"Label"
    private layoutSeparatingValues = false;

    constructor(props) {
        super(props);
    }

    getEmptyMappedValue = () => {
        //  label or color
        let kindDescrObj = getKindDescrObject(this.props.kind);
        return kindDescrObj.emptyMappedValue;
    };

    isEmptyIntervalsValue = () => {
        let obj = this.props.value;
        return obj == null || obj.values == null || obj.values.length === 0;
    };

    getValue = () => {
        let result = this.props.value;

        //LL: emptyLabel = emptyMappedValue, depends on kind
        if (result == null) {
            result = { labels: [this.getEmptyMappedValue()], values: [] };
        } else {
            result = _.clone(result);
            if (result.values == null) {
                result = _.extend(result, {
                    labels: [this.getEmptyMappedValue()],
                    values: []
                });
            }
        }

        result.values = result.values.slice(0);
        result.values.push(Infinity);
        result.values.unshift(-Infinity);

        return result;
    };

    getInitial = (type: string) => {
        switch (type) {
            case ATTRIBUTE_TYPES.STRING:
            case 'string':
                return 'text';
            case ATTRIBUTE_TYPES.INTEGER:
                return 0;
            case ATTRIBUTE_TYPES.REAL:
            case 'number':
                return 0;
            case ATTRIBUTE_TYPES.DATE:
            case ATTRIBUTE_TYPES.DATETIME:
                return Globalize.formatDate(new Date(), {
                    raw: DateValueFormat
                }); // 'yyyy-MM-dd'
            case ATTRIBUTE_TYPES.TIME:
                let D = getMinTimeDate();
                //D.setSeconds(D.getSeconds() + 1);  //  for Time <=
                let timeStepValue = this.props.value.step != null ? this.props.value.step : timeStepDefault;

                //LL: why was it ? for constrains <   But not timeStepValue, 1 minute or 1 second ?
                D.setMinutes(D.getMinutes() + timeStepValue); //  for Time <=
                //D.setMinutes(D.getMinutes() + 1);
                return Globalize('en').formatDate(D, { raw: TimeValueFormat }); //LL: 17.12.19: was error for Danish

            default:
                return null;
        }
    };

    getNext = (type: string, value) => {
        if (value === -Infinity) {
            return this.getInitial(type);
        }

        switch (type) {
            case ATTRIBUTE_TYPES.STRING:
            case 'string':
                return value + '_';

            case ATTRIBUTE_TYPES.INTEGER:
                let numberStepValue = this.props.value.step != null ? this.props.value.step : numberStepDefault;
                return value + numberStepValue;

            case ATTRIBUTE_TYPES.REAL:
            case 'number':
                let precision = this.props.value.precision != null ? this.props.value.precision : precisionDefault;
                let numberStepValueR = this.props.value.step != null ? this.props.value.step : numberStepDefault;
                //  .toFixed returns a string. Make sure to wrap the result in Number()
                return Number((value + numberStepValueR).toFixed(precision));

            case ATTRIBUTE_TYPES.DATE:
            case ATTRIBUTE_TYPES.DATETIME:
                //LL: see value = "2001-12-31T21:00:00+00:00"  -> Globalization.parseDate returns null
                let d = Globalization.parseDate(value, { raw: DateValueFormat }); // 'yyyy-MM-dd'

                if (d == null) {
                    d = new Date(value);
                }

                if (d == null) {
                    console.log("DiscreteIntervals: Error in getNext for 'date'");
                    return null;
                }

                let dateStepValue = this.props.value.step != null ? this.props.value.step : dateStepDefault;

                d.setDate(d.getDate() + dateStepValue);

                if (Number.isNaN(d)) {
                    console.log("DiscreteIntervals: Error in getNext for 'date': (value+step) is not date");
                    return null;
                }

                return Globalize.formatDate(d, { raw: DateValueFormat });

            case ATTRIBUTE_TYPES.TIME:
                let time = Globalization.parseDate(value, { raw: TimeValueFormat });

                if (time == null) {
                    time = new Date(value);
                }

                if (time == null) {
                    console.log("DiscreteIntervals: Error in getNext for 'time'");
                    return null;
                }

                let timeStepValue = this.props.value.step ?? timeStepDefault;
                let maxTime = getMaxTimeDate();
                let minutes = time.getMinutes();

                time.setMinutes(minutes + timeStepValue);

                if (Number.isNaN(time)) {
                    console.log("DiscreteIntervals: Error in getNext for 'time': (value+step) is not date");
                    return null;
                }

                if (time > maxTime) {
                    return null;
                }

                time.setSeconds(0);
                //return Globalize.formatDate(t, { raw: TimeValueFormat });
                return Globalize('en').formatDate(time, { raw: TimeValueFormat }); //LL: 17.12.19: was error for Danish
            default:
                return null;
        }
    };

    getSplit = (type: string, valueTo: any, valueFrom: any) => {
        let valueFrom_IsSet = valueFrom !== -Infinity;
        let valueTo_IsNotSet = valueTo === Infinity;

        if (valueTo_IsNotSet && !valueFrom_IsSet) {
            return null;
        }
        if (valueTo_IsNotSet) {
            return this.getNext(type, valueFrom);
        }

        switch (type) {
            case ATTRIBUTE_TYPES.STRING:
            case 'string':
                //return '_' + valueTo;  // ???  No, out of order anyway
                return valueFrom + '_';

            case ATTRIBUTE_TYPES.INTEGER:
                if (valueFrom_IsSet) {
                    if (valueTo - 1 <= valueFrom) {
                        return null;
                    } else {
                        //  middle:
                        let iStep = Math.round((valueTo - valueFrom) / 2);
                        return valueFrom + iStep;
                    }
                } else {
                    let numberStepValue = this.props.value.step != null ? this.props.value.step : numberStepDefault;
                    return valueTo - numberStepValue;
                }

            case ATTRIBUTE_TYPES.REAL:
            case 'number':
                if (valueFrom_IsSet) {
                    let deltaR = valueTo - valueFrom;

                    //  middle:
                    //return valueTo - deltaR/2;

                    //LL: now with precision
                    let precision = this.props.value.precision != null ? this.props.value.precision : precisionDefault;

                    //LL: when valueTo, valueFrom are fractional, we must apply rounding to deltaR
                    //   for example: 4.4 - 4.3 = 0.10000000000053
                    //         and will be > minDelta
                    //   in other case deltaR can be 0.000000000009
                    deltaR = Number(deltaR.toFixed(precision));

                    let minDelta = Math.pow(10, -precision);
                    if (deltaR <= minDelta) {
                        return null;
                    }

                    //  .toFixed returns a string. Make sure to wrap the result in Number()
                    return Number((valueTo - deltaR / 2).toFixed(precision));
                } else {
                    let numberStepValue = this.props.value.step != null ? this.props.value.step : numberStepDefault;
                    return valueTo - numberStepValue;
                }

            case ATTRIBUTE_TYPES.DATE:
            case ATTRIBUTE_TYPES.DATETIME:
                //  https://github.com/globalizejs/globalize/issues/500
                let d = Globalization.parseDate(valueTo, { raw: DateValueFormat }); // 'yyyy-MM-dd'
                if (d == null) {
                    d = Globalization.parseDate(valueTo, {
                        raw: DateTimeValueFormatT
                    });
                }
                if (d == null) {
                    console.log("DiscreteIntervals: Error in getSplit for 'date', valueTo is not date");
                    return null;
                }

                let dateStepValue = this.props.value.step != null ? this.props.value.step : dateStepDefault;

                if (valueFrom_IsSet) {
                    let dPrev = Globalization.parseDate(valueFrom, {
                        raw: DateValueFormat
                    }); // 'yyyy-MM-dd'

                    if (dPrev == null) {
                        dPrev = Globalization.parseDate(valueFrom, {
                            raw: DateTimeValueFormatT
                        });
                    }

                    if (dPrev == null) {
                        console.log("DiscreteIntervals: Error in getSplit for 'date', valueFrom is not date");
                        return null;
                    }

                    let dAbs = d.getTime(); // valueTo
                    //  if middle:
                    let dPrevAbs = dPrev.getTime();

                    //LL: for "date" can check that difference > 1 day(=1000*60*60*24 = 86400000)
                    if (type === ATTRIBUTE_TYPES.DATE) {
                        if (dAbs - dPrevAbs <= 86400000) {
                            return null;
                        }
                    }

                    if (type === ATTRIBUTE_TYPES.DATETIME) {
                        // 60000 = 1 minute, 1000 = 1 sec  let's use precision seconds
                        if (dAbs - dPrevAbs < 2000) {
                            return null;
                        }
                    }

                    let dStep = Math.round((dAbs - dPrevAbs) / 2);
                    let dMiddle = new Date(dPrevAbs + dStep);
                    //  no need ? it is middle
                    //if (isNaN(dMiddle)) {
                    //    console.log("DiscreteIntervals: NaN in getSplit for 'date' (when From is set): dMiddle is not date");
                    //    return null;
                    //}

                    return Globalize.formatDate(dMiddle, {
                        raw: DateValueFormat
                    });
                } else {
                    // from = -Infinity
                    d.setDate(d.getDate() - dateStepValue);

                    if (Number.isNaN(d)) {
                        console.log(
                            "DiscreteIntervals: NaN in getSplit for 'date'(when From not set): (valueTo-step) is not date"
                        );
                        return null;
                    }

                    return Globalize.formatDate(d, { raw: DateValueFormat });
                }

            case ATTRIBUTE_TYPES.TIME:
                let t = Globalization.parseDate(valueTo, { raw: TimeValueFormat }); // 'yyyy-MM-ddTHH:mm:ss'

                if (t == null) {
                    console.log("DiscreteIntervals: NaN in getSplit for 'time', valueTo is not date/time string");
                    return null;
                }

                let timeStepValue = this.props.value.step != null ? this.props.value.step : timeStepDefault;
                let minTime = getMinTimeDate();

                if (valueFrom_IsSet) {
                    let tPrev = Globalization.parseDate(valueFrom, {
                        raw: TimeValueFormat
                    }); // 'yyyy-MM-ddTHH:mm:ss'

                    if (tPrev == null) {
                        console.log("DiscreteIntervals: NaN in getSplit for 'time', valueFrom is not date/time string");
                        return null;
                    }

                    let tAbs = t.getTime();
                    //  if middle:
                    let tPrevAbs = tPrev.getTime();

                    //LL: can check that difference > 1 second (=1000)
                    if (tAbs - tPrevAbs <= 1000) {
                        return null;
                    }

                    let tStep = Math.round((tAbs - tPrevAbs) / 2);
                    let tMiddle = new Date(tPrevAbs + tStep);
                    //return Globalize.formatDate(tMiddle, { raw: TimeValueFormat });
                    return Globalize('en').formatDate(tMiddle, {
                        raw: TimeValueFormat
                    }); //LL: 17.12.19: was error for Danish
                } else {
                    t.setMinutes(t.getMinutes() - timeStepValue);

                    if (Number.isNaN(t)) {
                        console.log(
                            "DiscreteIntervals: NaN in getSplit for 'time'(when From not set): (valueTo-step) is not date"
                        );
                        return null;
                    }

                    if (t <= minTime) {
                        return null;
                    }
                    //return Globalize.formatDate(t, { raw: TimeValueFormat });
                    return Globalize('en').formatDate(t, {
                        raw: TimeValueFormat
                    }); //LL: 17.12.19: was error for Danish
                }

            default:
                return null;
        }
    };

    checkType = (type, value) => {
        switch (type) {
            case 's':
            case 'string':
                return typeof value === 'string';
            case 'i':
                return typeof value === 'number';
            case 'r':
            case 'number':
                return typeof value === 'number';
            case 'date':
                return typeof value === 'string';
            case 'datetime':
                return typeof value === 'string';
            case 'time':
                return typeof value === 'string';
            default:
                return false;
        }
    };

    handleOnAddInterval = () => {
        const value = this.getValue();
        //LL: getNext can return null for Time, also for Date when too large step
        let nextVal = this.getNext(this.props.type, value.values[value.values.length - 2]);

        if (nextVal != null) {
            value.labels.push(this.getEmptyMappedValue()); //LL: emptyLabel = emptyMappedValue, depends on kind
            value.values.splice(-1, 0, nextVal);
            this.processChange(value);
        }
    };

    handleRemoveInterval = (i) => {
        let next = this.getValue();

        next.values = next.values.slice(0);
        next.labels = next.labels.slice(0);

        next.labels.splice(i, 1);

        //if (i === this.props.value.labels.length - 1) {
        //    next.values.splice(i, 1);
        //}
        //else {
        //    next.values.splice(i + 1, 1);
        //}
        //LL: 01.09.19: my flag:
        if (this.layoutSeparatingValues) {
            // new
            next.values.splice(i, 1);
        } else {
            // old
            if (i === this.props.value.labels.length - 1) {
                next.values.splice(i, 1);
            } else {
                next.values.splice(i + 1, 1);
            }
        }

        this.processChange(next);
    };

    getSplitInterval = (next, i) => {
        //  next = this.getValue();
        //   1st val (with index = 0) is always -Infinity  (added in getValue)
        //   line index = i, value index = i + 1, insert value before i + 1

        let valueTo = next.values[i + 1];
        let valueFrom = next.values[i];

        let newVal = this.getSplit(this.props.type, valueTo, valueFrom);

        return newVal;
    };

    handleSplitInterval = (i) => {
        //LL: 27.05.19: "canSplit" also for "empty" intervals (both Margins are Infinity)
        if (this.isEmptyIntervalsValue()) {
            this.handleOnAddInterval();
            return;
        }

        let next = this.getValue();

        next.values = next.values.slice(0);
        next.labels = next.labels.slice(0);
        next.labels.splice(i, 0, this.getEmptyMappedValue()); //   copy !!!

        let newVal = this.getSplitInterval(next, i);

        if (newVal != null) {
            next.values.splice(i + 1, 0, newVal);
            this.processChange(next);
        } else {
            console.log('ERROR: handleSplitInterval:  newVal is null');
        }
    };

    canSplitInterval = (i) => {
        //LL: 27.05.19: "canSplit" also for "empty" intervals (both Margins are Infinity)
        if (this.isEmptyIntervalsValue()) {
            return true;
        }

        let next = this.getValue();
        let newVal = this.getSplitInterval(next, i);

        return newVal != null;
    };

    //LL: 28.05.19: handleIntervalChange will check validation
    handleIntervalChange = (value, i) => {
        if (this.checkType(this.props.type, value) !== true) {
            return;
        }

        let next = this.getValue();
        next.values = next.values.slice(0);

        //next.values.splice(i + 1, 1, value);
        //LL: 01.09.19: my flag:
        if (this.layoutSeparatingValues) {
            // new
            next.values.splice(i, 1, value);
        } else {
            // old
            next.values.splice(i + 1, 1, value);
        }

        let isValid = DiscreteIntervals.validateDiscreteIntervals(next, this.props.type); //LL: 29.05.19

        if (isValid) {
            this.processChange(next);
        } else {
            this.processChange(next, true);
        }
    };

    handleLabelChange = (value, i) => {
        let next = this.getValue();
        next.labels = next.labels.slice(0);
        next.labels.splice(i, 1, value);

        this.processChange(next);
    };

    handleStepChange = (value) => {
        let obj = _.clone(this.props.value || {});

        let val: any;
        if (this.props.type === 'r' || this.props.type === 'number') {
            val = parseFloat(value);
        } else {
            val = parseInt(value);
        }

        if (isNaN(val) || val == null) {
            delete obj.step;
        } else {
            obj.step = val;
        }

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(obj);
        }
    };

    handlePrecisionChange = (value) => {
        let obj = _.clone(this.props.value || {});

        let val = parseInt(value);
        if (isNaN(val) || val == null) {
            delete obj.precision;
        } else {
            obj.precision = val;
        }

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(obj);
        }
    };

    handleLabelChange_NullMapping = (value) => {
        let obj = _.clone(this.props.value || {});
        if (value == null) {
            delete obj.nullMappedValue;
        } else {
            obj.nullMappedValue = value;
        }
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(obj);
        }
    };

    handleRemoveInterval_NullMapping = () => {
        let obj = _.clone(this.props.value || {});
        delete obj.nullMappedValue;
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(obj);
        }
    };

    handleLabelChange_TrueMapping = (value) => {
        let obj = _.clone(this.props.value || {});
        if (value == null) {
            delete obj.trueMappedValue;
        } else {
            obj.trueMappedValue = value;
        }
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(obj);
        }
    };

    handleRemoveInterval_TrueMapping = () => {
        let obj = _.clone(this.props.value || {});
        delete obj.trueMappedValue;
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(obj);
        }
    };

    handleLabelChange_FalseMapping = (value) => {
        let obj = _.clone(this.props.value || {});

        if (value == null) {
            delete obj.falseMappedValue;
        } else {
            obj.falseMappedValue = value;
        }
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(obj);
        }
    };

    handleRemoveInterval_FalseMapping = () => {
        let obj = _.clone(this.props.value || {});
        delete obj.falseMappedValue;

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(obj);
        }
    };

    processChange = (value, hasIntervalError?) => {
        //LL: 07.06.19:
        //  about the Case when Intervals were created and afterwards all removed (call in handleRemoveInterval)
        //LL: what to do with last label when there are no values ?
        //    1. we can set values and labels to null (~~ normalization)
        //    2. or use this last label (color) for full Interval (-Infinity, +Infinity)
        //
        //LL: 2. variant is more logical, but then we must show this last label/color in <Interval>
        //LL: previous practice was NOT to use such labels (in UserDefinedIntervals) (but last color IS actually applied in Charts XC),
        //       but also there was not normalization
        //
        //LL: So, my decision: to normalize object (set of Intervals): i.e. remove labels when last Interval is deleted
        //   or better:
        //  DIFFER by "kind":  ============================
        //    - for "color" use last color
        //    - for "label" remove labels, no don't remove, they won't be used in UserDefinedIntervals
        //  That will go with old practice with UserDefinedIntervals
        //       and better for coloring

        if (value != null) {
            value = _.clone(value);

            value.values = value.values.slice(0); // copy
            value.values.shift(); // rem Infinity
            value.values.pop(); // rem Infinity

            //LL: 07.06.19: try
            //if (value.values.length == 2) { // only Infinities
            //    delete value.values;
            //    delete value.labels;
            //}
            //else {
            //    value.values = value.values.slice(0);  // copy
            //    value.values.shift();  // rem Infinity
            //    value.values.pop();  // rem Infinity
            //}
        }

        //LL: 30.05.19: my flag  TRY
        if (DateTimeFunctions.isTypeOfTime(this.props.type)) {
            if (!TimeValuesAsDate) {
                //LL; convert to 'HH:mm:ss'
                //  values are time-date-strings ("1899-12-31T16:03:00"),
                //            it is DateTimeFunctions.TimeValueFormat = 'yyyy-MM-ddTHH:mm:ss'
                let values = _.map(value.values, (dateString: string) => {
                    dateString = DateTimeFunctions.convertTimeValueAsDateToString(dateString);
                    return dateString;
                });
                value.values = values;
            }
        }

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value, hasIntervalError);
        }
    };

    arrangeButtonHandler = () => {
        let value = this.props.value; // without Infinity
        //let value = this.getValue();  // with Infinity
        let sorted = DiscreteIntervals.sortDiscreteIntervals(value, this.props.type); // newVal

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(sorted, false);
        }
    };

    render() {
        let value = this.getValue(); // with Infinity

        if (!TimeValuesAsDate) {
            //LL: is true, so is not called
            if (DateTimeFunctions.isTypeOfTime(this.props.type)) {
                //LL; convert from 'HH:mm:ss' to time-date-strings ("1899-12-31T16:03:00"),
                //            it is DateTimeFunctions.TimeValueFormat = 'yyyy-MM-ddTHH:mm:ss'
                let values = _.map(value.values, (timeString) => {
                    if (timeString === Infinity || timeString === -Infinity) {
                        return timeString;
                    }
                    let dateString = timeString;
                    let t = Globalization.parseDate(timeString, {
                        raw: TimeDisplayFormat
                    });
                    if (t != null) {
                        dateString = Globalize.formatDate(t, {
                            raw: TimeValueFormat
                        }); // "en"
                    }
                    return dateString;
                });
                value.values = values;
            }
        }

        let stepValue;
        //if (this.props.value != null) {
        //    stepValue = this.props.value.step;
        //}
        //LL: 21.08.19: Set "step" only for Time, for others use default: (Leo does not want "step")
        if (this.props.type === 'time') {
            if (this.props.value != null) {
                stepValue = this.props.value.step;
            }
        }
        if (stepValue == null) {
            stepValue = getStepDefault(this.props.type);
        }

        //LL: 01.07.19: { kind: DiscreteIntervalsKind.label, columnHeader: "Label", emptyMappedValue: "", renderComponent: LabelRenderComponent }
        let kindDescrObj = getKindDescrObject(this.props.kind);
        let renderComponent = kindDescrObj.renderComponent;
        let labelTxt = kindDescrObj.columnHeader;

        // ============================================================
        //LL: 29.08.19: layoutSeparatingValues my flasg: 2 columns: "Separating Value" and ~~"Label"

        let columnHeaders2;
        let intervals2;

        if (this.layoutSeparatingValues) {
            labelTxt = 'Result (' + labelTxt + ')';

            let columnHeaders2_item = (
                <Interval2
                    key={'Interval_columnHeaders'}
                    label={labelTxt}
                    separatingValue={'Separating Values'}
                    next={null}
                    prev={null}
                    step={stepValue}
                    i={-1}
                    type={this.props.type}
                    kind={this.props.kind}
                    canSplitInterval={false}
                    glob={this.props.glob}
                />
            );

            columnHeaders2 = <div className="intervals-container-layout-separatingValues">{columnHeaders2_item}</div>;

            let points = _.map(value.labels, (label, i) => {
                return (
                    <Interval2
                        key={i}
                        label={label}
                        separatingValue={value.values[i]}
                        next={value.values[i + 1]}
                        prev={i === 0 ? null : value.values[i - 1]}
                        step={stepValue}
                        i={i}
                        type={this.props.type}
                        kind={this.props.kind}
                        renderComponent={renderComponent}
                        onAddInterval={this.handleOnAddInterval}
                        onChange={this.handleIntervalChange}
                        onLabelChange={this.handleLabelChange}
                        onRemove={this.handleRemoveInterval}
                        onSplit={this.handleSplitInterval}
                        canSplitInterval={this.canSplitInterval(i)}
                        glob={this.props.glob}
                    />
                );
            });

            let N = value.labels.length;
            // canSplitInterval={ this.canSplitInterval(N) }
            points.push(
                <Interval2
                    key={N}
                    noLabel={true}
                    label={null}
                    separatingValue={value.values[N]}
                    next={null}
                    prev={N === 0 ? null : value.values[N - 1]}
                    step={stepValue}
                    i={N}
                    type={this.props.type}
                    kind={this.props.kind}
                    renderComponent={renderComponent}
                    onAddInterval={this.handleOnAddInterval}
                    onChange={this.handleIntervalChange}
                    onLabelChange={this.handleLabelChange}
                    onRemove={this.handleRemoveInterval}
                    onSplit={this.handleSplitInterval}
                    canSplitInterval={false}
                    glob={this.props.glob}
                />
            );

            //   https://reactjs.org/docs/fragments.html
            //return (
            //    <React.Fragment>
            //        <ChildA />
            //        <ChildB />
            //        <ChildC />
            //    </React.Fragment>
            //);

            //   ~~ ok
            //let points = _.map(
            //    value.labels,
            //    (label, i) => {
            //        return (
            //            <React.Fragment>
            //                <div className="from">{ value.values[i + 1] }</div>
            //                <div className="result">{ label }</div>
            //            </React.Fragment>
            //        );
            //    }
            //);

            // ==========================================================

            //intervals2 =
            //    <div className="intervals-container-layout-separatingValues">
            //        { points }
            //    </div>;
            intervals2 = <div className="intervals-container-layout-separatingValues-vert">{points}</div>;
        }
        // ============================================================

        //LL: 26.10.21: 'boolean' type: no <Intervals>, only 2 values

        let columnHeaders;
        if (this.props.type !== 'boolean') {
            columnHeaders = (
                <Interval
                    key={'Interval_columnHeaders'}
                    label={labelTxt}
                    left={'From'}
                    right={'To'}
                    next={null}
                    step={stepValue}
                    i={-1}
                    type={this.props.type}
                    kind={this.props.kind}
                    canSplitInterval={false}
                    themeObj={this.props.themeObj}
                    glob={this.props.glob}
                />
            );
        }

        //LL:  precision ???
        //let precision = this.props.value.precision != null ? this.props.value.precision : precisionDefault;
        ////  .toFixed returns a string. Make sure to wrap the result in Number()
        //return Number((valueTo - deltaR/2).toFixed(precision));

        let intervals;

        if (this.props.type !== 'boolean') {
            //LL: labels can be "colors"
            intervals = _.map(value.labels, (label, i) => {
                return (
                    <Interval
                        key={i}
                        label={label}
                        left={value.values[i]}
                        right={value.values[i + 1]}
                        next={value.values[i + 2]}
                        step={stepValue}
                        i={i}
                        type={this.props.type}
                        kind={this.props.kind}
                        renderComponent={renderComponent}
                        themeObj={this.props.themeObj}
                        //allowColorFunctionsFlag={this.props.allowColorFunctionsFlag}
                        canSplitInterval={this.canSplitInterval(i)}
                        glob={this.props.glob}
                        onAddInterval={this.handleOnAddInterval}
                        onChange={this.handleIntervalChange}
                        onLabelChange={this.handleLabelChange}
                        onRemove={this.handleRemoveInterval}
                        onSplit={this.handleSplitInterval}
                    />
                );
            });
        }

        //LL: 21.08.19: Leo asks to remove "step". Cannot agree, but decide to leave it only for Time
        //LL: 31.05.19: for all types now
        let stepElem;
        let stepLabel;
        let stepInteger = true;

        switch (this.props.type) {
            case 's':
            case 'string':
            case 'boolean':
                break;
            case 'i':
            case 'r':
            case 'number':
                //stepLabel = "Step (>0):";  // "Step Interval(>0):"
                break;
            case 'date':
            case 'datetime':
                //stepLabel = "Step in days(>0):";  // "Step Interval in days(>0):"
                break;
            case 'time':
                //LL: 13.12.18: restored, add pickerTypeForTime ('list' or 'rollers') to DateField
                //LL: 12.12.18: not used now, in DateField pickerType="rollers" (not "list" is used for Time
                //stepLabel = "Step Interval in minutes:";
                //stepLabel = "Step Interval in minutes(" + timeStepMin + "-" + timeStepMax + "):";
                stepLabel = 'Step in minutes(' + timeStepMin + '-' + timeStepMax + '):';
                break;
            //default:
        }

        if (this.props.type === 'r' || this.props.type === 'number') {
            stepInteger = false;
        }

        let minStep;
        let maxStep;
        let minConstraintAllowEqual = false;

        if (this.props.type === 'time') {
            // minutes
            minStep = timeStepMin;
            maxStep = timeStepMax;
            minConstraintAllowEqual = true;
        } else {
            minStep = stepMin; // >0
        }

        if (stepLabel != null) {
            let styleTimeStep: React.CSSProperties = {
                marginBottom: '10px',
                width: '270px'
            };
            //LL:   rem:  positive={ true }, use minConstraintAllowEqual
            stepElem = (
                <div style={styleTimeStep}>
                    <label>
                        <span>{stepLabel}</span>
                    </label>
                    <NumberField
                        value={stepValue}
                        onChange={this.handleStepChange}
                        applyOnEnter={true}
                        integer={stepInteger}
                        minConstraintAllowEqual={minConstraintAllowEqual}
                        min={minStep}
                        max={maxStep}
                        options={{ inline: true }}
                    />
                </div>
            );
        }

        //LL: 21.06.19: for 'r'
        let precisionElem;

        if (this.props.type === 'r' || this.props.type === 'number') {
            let precisionValue =
                this.props.value != null && this.props.value.precision != null
                    ? this.props.value.precision
                    : precisionDefault;
            let stylePrecision: React.CSSProperties = {
                marginBottom: '10px',
                marginLeft: '20px',
                display: 'inline-block'
            };

            //LL: 13.10.20: add "max";  must be <=100 (for toFixed() function), but 10 seems enough
            precisionElem = (
                <div style={stylePrecision}>
                    <label>
                        <span>{'Precision (1-10):'}</span>
                    </label>
                    <div
                        style={{
                            marginLeft: '5px',
                            display: 'inline-block',
                            width: '50px'
                        }}
                    >
                        <NumberSpinnerExtended
                            value={precisionValue}
                            onChange={this.handlePrecisionChange}
                            applyOnEnter={true}
                            integer={true}
                            min={1}
                            max={10}
                        />
                    </div>
                </div>
            );
        }

        let arrangeButton;
        let arrangeButtonClass = 'btn btn-info'; // "btn btn-default";
        let arrangeButtonOnClick: any = this.arrangeButtonHandler;
        let isValid = DiscreteIntervals.validateDiscreteIntervals(value, this.props.type);

        if (!isValid) {
            arrangeButton = (
                <button className={arrangeButtonClass} style={{ marginLeft: '5px' }} onClick={arrangeButtonOnClick}>
                    {'Arrange correctly'}
                </button>
            );
        }

        let useNullValueMapping = true;

        if (this.props.useNullValueMapping != null) {
            useNullValueMapping = this.props.useNullValueMapping;
        }

        let nullValueElement;
        if (useNullValueMapping) {
            let styleNV: any = {
                marginTop: '5px',
                paddingTop: '5px',
                borderTop: 'solid 1px #cccccc'
            };

            let nullMappedValue = this.props.value.nullMappedValue;

            nullValueElement = (
                <div style={styleNV}>
                    <Interval
                        key={'Interval_nullValue'}
                        label={nullMappedValue}
                        left={'"Null" value'}
                        right={''}
                        next={null}
                        step={stepValue}
                        i={-2}
                        type={this.props.type}
                        kind={this.props.kind}
                        canSplitInterval={false}
                        renderComponent={renderComponent}
                        themeObj={this.props.themeObj}
                        glob={this.props.glob}
                        onLabelChange={this.handleLabelChange_NullMapping}
                        onRemove={this.handleRemoveInterval_NullMapping}
                    />
                </div>
            );
        }

        let booleanTypeElement;

        if (this.props.type === 'boolean') {
            let styleB: any = {
                marginTop: '5px',
                paddingTop: '5px',
                borderTop: 'solid 1px #cccccc'
            };

            let trueMappedValue = this.props.value.trueMappedValue;
            let trueValueElement = (
                <div style={styleB}>
                    <Interval
                        key={'Interval_trueValue'}
                        label={trueMappedValue}
                        left={'"True" value'}
                        right={''}
                        next={null}
                        step={stepValue}
                        i={-3}
                        type={this.props.type}
                        kind={this.props.kind}
                        canSplitInterval={false}
                        renderComponent={renderComponent}
                        themeObj={this.props.themeObj}
                        glob={this.props.glob}
                        onLabelChange={this.handleLabelChange_TrueMapping}
                        onRemove={this.handleRemoveInterval_TrueMapping}
                    />
                </div>
            );

            let falseMappedValue = this.props.value.falseMappedValue;
            let falseValueElement = (
                <div>
                    <Interval
                        key={'Interval_falseValue'}
                        label={falseMappedValue}
                        left={'"False" value'}
                        right={''}
                        next={null}
                        step={stepValue}
                        i={-4}
                        type={this.props.type}
                        kind={this.props.kind}
                        canSplitInterval={false}
                        renderComponent={renderComponent}
                        themeObj={this.props.themeObj}
                        glob={this.props.glob}
                        onLabelChange={this.handleLabelChange_FalseMapping}
                        onRemove={this.handleRemoveInterval_FalseMapping}
                    />
                </div>
            );

            booleanTypeElement = (
                <React.Fragment>
                    {trueValueElement}
                    {falseValueElement}
                </React.Fragment>
            );
        }

        //LL:  { intervals2 } is try, empty;  columnHeaders2
        if (this.layoutSeparatingValues) {
            columnHeaders = null;
            intervals = null;
        }

        return (
            <div className="discrete-intervals-component">
                <label>{'Data type: ' + Utilities.explainAttributeType(this.props.type)}</label>
                {precisionElem}
                {stepElem}
                {arrangeButton}
                {nullValueElement}
                {booleanTypeElement}
                {columnHeaders}
                {intervals}
                {columnHeaders2}
                {intervals2}
            </div>
        );
    }
}

interface IIntervalSelectPopupOptions extends IPopupOptions {
    value;
    type: string;
    notUseRegularTab?: boolean;
    themeObj?: IValuesCollection;
    allowColorFunctionsFlag?: boolean;
    onChange(value): void;
}

class IntervalSelectPopup extends React.Component<
    {
        zIndex: number;
        options: IIntervalSelectPopupOptions;
        close(): void;
        glob: IGlob;
    },
    {
        value;
        hasIntervalError;
        height?: number; //LL: as in FormatChooser
        width?: number; //LL: as in FormatChooser
    }
> {
    private references: {
        popoverContent?: HTMLElement;
    } = {};

    constructor(props) {
        super(props);

        const valueOrig = $.extend(true, {}, this.props.options.value);

        this.state = {
            value: valueOrig, //this.props.options.value
            hasIntervalError: false,
            height: 500, //LL: as in FormatChooser  ??? can change, depends on current Tab  Reset in DidMount
            width: 530 //LL: as in FormatChooser   sass - 520      Reset in DidMount
        };
    }

    componentDidMount() {
        const dialog = this.references.popoverContent as HTMLElement;
        // VR: needed for JEST testing: "if(dialog != null)"
        if (dialog != null) {
            this.setState(
                _.extend(this.state, {
                    height: dialog.clientHeight,
                    width: dialog.clientWidth
                })
            );
        }
    }

    handleChange = (value, hasIntervalError?) => {
        this.setState({
            value: value,
            hasIntervalError: hasIntervalError
        });

        // if (typeof this.props.options.onChange === 'function') {
        //     this.props.options.onChange(value);
        // }
    };

    closeButtonHandler = () => {
        let hasError = this.state.hasIntervalError;

        if (hasError != true) {
            let errors = validateWhole(this.state.value, this.props.options.type);

            if (errors.length > 0) {
                hasError = true;
            }
        }

        if (hasError === true) {
            //LL: 28.05.19:  no:
            //this.props.options.glob.AppActions.showNotification_Warning('Configuration is not valid. Some fields have wrong value');
        } else {
            if (typeof this.props.options.onChange === 'function') {
                this.props.options.onChange(this.state.value);
            }
            this.props.close();
        }
    };

    escapeButtonHandler = () => {
        // if (typeof this.props.options.onChange === 'function') {
        //     this.props.options.onChange(this.state.valueOrig);
        // }
        this.props.close();
    };

    getDiscreteIntervals = () => {
        return (
            <DiscreteIntervals
                value={this.state.value}
                type={this.props.options.type}
                kind={DiscreteIntervalsKind.color}
                themeObj={this.props.options.themeObj}
                allowColorFunctionsFlag={this.props.options.allowColorFunctionsFlag}
                onChange={this.handleChange}
                glob={this.props.glob}
            />
        );
    };

    render() {
        const popoverStyle = Utilities.getPopoverStyle(this.props.options, {
            width: this.state.width,
            height: this.state.height
        });

        let style = {
            display: 'block',
            left: popoverStyle.left,
            top: popoverStyle.top,
            zIndex: this.props.zIndex
        };

        let popupTitle = 'Color Scale'; //LL: this is by Leo, was "Color Intervals";

        let styleDefineIntervals: any = { borderTop: '1px solid gray' };
        let labelText = 'Define Intervals:';
        //LL: 21.08.19: Leo wants without header:
        //   I propose to leave Header for IntervalSelect and remove for ColorScale ?
        let header = <label>{labelText}</label>;
        let showHeader = false; //LL: OK

        if (showHeader === false) {
            styleDefineIntervals = {};
            header = null;
        }

        let intervalContent = this.getDiscreteIntervals();

        let upperContent = (
            <div className="popover-body">
                {header}
                <div style={styleDefineIntervals}>{intervalContent}</div>
            </div>
        );

        let mainContentElem = <div className="separate-upper-tab">{upperContent}</div>;

        let errors = validateWhole(this.state.value, this.props.options.type);
        let styleError: any = { color: 'red', margin: '10px' };
        let errorsElem = <div style={styleError}>{errors.join(', ')}</div>;

        //LL: 28.05.19:
        //LL: try disabled for OK-button,  ok
        let hasError = this.state.hasIntervalError;
        if (errors.length > 0) {
            hasError = true;
        }

        let okButtonClass = 'btn btn-success';
        if (hasError === true) {
            okButtonClass += ' disabled';
        }

        return (
            <div className="discrete-intervals">
                <div
                    className={'popover discrete-intervals-popover ' + popoverStyle.side}
                    style={style}
                    ref={(input) => {
                        this.references.popoverContent = input;
                    }}
                >
                    <div className="arrow" style={{ top: popoverStyle.arrowTop }}></div>

                    <h3 className="popover-header">
                        {popupTitle}
                        <button
                            type="button"
                            className="close"
                            title="Cancel all changes"
                            onClick={this.escapeButtonHandler}
                        >
                            ×
                        </button>
                    </h3>

                    {errorsElem}

                    {mainContentElem}

                    <div className="modal-footer">
                        <button className={okButtonClass} onClick={this.closeButtonHandler}>
                            {'OK'}
                        </button>
                        <button className="btn btn-default" onClick={this.escapeButtonHandler}>
                            {'Cancel'}
                        </button>
                    </div>
                </div>
                <div className="modal-backdrop fade show"></div>
            </div>
        );
    }
}

export class DiscreteIntervals_Color extends React.Component<
    {
        value;
        type: string;
        themeObj?: IValuesCollection;
        allowColorFunctionsFlag?: boolean; //LL: 05.11.19,  sent in ColorMappingForNumericField  getColorIntervals
        glob: IGlob;
        onChange(value): void;
    },
    {
        popup?: boolean; //LL: 28.11.22: PPP
        isInSettingsView?: boolean; //LL: 28.11.22: PPP
        isInModalDialog?: boolean; //LL: 28.11.22: PPP
    }
> {
    private references: {
        container?: HTMLDivElement; // ".discrete_intervals_Color"
    } = {};

    constructor(props) {
        super(props);

        this.state = { popup: false };
    }    

    componentDidMount() {
        //LL: it is better, above sometimes is wrong
        let d2 = $(this.references.container).parents('.settings-view');
        let isInSettingsView2 = d2 != null && d2.length > 0;

        let f2 = $(this.references.container).parents('.modal-dialog');
        let isInModalDialog2 = f2 != null && f2.length > 0;

        this.setState({ isInSettingsView: isInSettingsView2, isInModalDialog: isInModalDialog2 });
    }

    componentWillUnmount() {}

    handleChange = (value) => {
        //   value:  { labels, values }
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value); //LL: to caller (ColormappingForNumeric)
        }
    };

    handleClose = () => {
        this.setState({ popup: false });
    };

    handleSelectorShow = (e) => {
        const offset = $(e.target).offset();

        //LL: 28.11.22 PPP
        //LL: problem is in e.stopPropagation();
        //  When from Config (from a Dialog), stopPropagation must NOT BE
        //  When from Administration/Settings/Options, stopPropagation must BE
        //  When from Administration/Themes, stopPropagation must NOT BE

        let popup = this.state.popup;
        let isInSettingsView = this.state.isInSettingsView;
        if (isInSettingsView === true && popup === true) {
            e.preventDefault();
            //return;
        }

        //LL: 28.11.22: PPP
        //LL: see DiscreteIntervals.tsx (DiscreteIntervals_forKind) and PalettesField
        const useFadeShow = true;
        e.preventDefault();
        // see this.setState({isInSettingsView: isInSettingsView, isInModalDialog: isInModalDialog});
        if (this.state.isInSettingsView === true && useFadeShow) {
            //if (this.state.isInSettingsView === true) {
            //if (this.state.isInSettingsView === true && popup !== true) {
            e.stopPropagation();
        }

        //  notUseRegularTab: this.props.notUseRegularTab, //IL. To prevent Regular intervals tab. Used in Gis icons
        this.props.glob.DialogActions.createPopup<IIntervalSelectPopupOptions>('custom', {
            top: offset.top,
            left: offset.left,
            value: this.props.value,
            type: this.props.type,
            themeObj: this.props.themeObj,
            allowColorFunctionsFlag: this.props.allowColorFunctionsFlag,
            onChange: this.handleChange,
            close: this.handleClose,
            component: IntervalSelectPopup
        });

        this.setState({ popup: true });
    };

    render() {
        let colors;
        //let title = "";

        let colorNull; //LL: 14.11.19: nullMappedValue
        let colorTrue, colorFalse; //LL: 29.10.21

        if (this.props.value == null || (this.props.value.values == null && this.props.value.nullMappedValue == null)) {
            colors = <em className="empty" onClick={this.handleSelectorShow}></em>;
        } else {
            //  this.props.value:  { values: [], labels: [] }   labels are colors
            //LL:  for colors:  ======================

            if (this.props.value.values != null) {
                //LL: to calculate tooltips:   (see getValue)
                let values = this.props.value.values.slice(0);

                if (this.props.type === 'time') {
                    values = _.map(values, (dateString: string) => {
                        dateString = convertTimeValueAsDateToString(dateString);
                        return dateString;
                    });
                }
                values.push(Infinity);
                values.unshift(-Infinity);

                //LL: labels are "colors"
                colors = _.map(this.props.value.labels, (color: any, i) => {
                    let title = getIntervalPlaceholderValue(values[i], values[i + 1], this.props.type, true);
                    let styleColor: React.CSSProperties = {
                        backgroundColor: color
                    };
                    return <div className="color" style={styleColor} key={i} title={title}></div>;
                });
            }

            if (this.props.type === 'boolean') {
                if (this.props.value.trueMappedValue != null) {
                    let title = getIntervalPlaceholderValue(null, true, this.props.type, true);
                    let styleColor: React.CSSProperties = {
                        backgroundColor: this.props.value.trueMappedValue
                    };
                    colorTrue = <div className="color" style={styleColor} key={-2} title={title}></div>;
                }
                if (this.props.value.falseMappedValue != null) {
                    let title = getIntervalPlaceholderValue(null, false, this.props.type, true);
                    let styleColor: React.CSSProperties = {
                        backgroundColor: this.props.value.falseMappedValue
                    };
                    colorFalse = <div className="color" style={styleColor} key={-3} title={title}></div>;
                }
            }

            if (this.props.value.nullMappedValue != null) {
                let title = getIntervalPlaceholderValue(null, null, this.props.type, true);
                let styleColor: React.CSSProperties = {
                    backgroundColor: this.props.value.nullMappedValue
                };

                colorNull = <div className="color" style={styleColor} key={-1} title={title}></div>;
            }
        }

        return (
            <div
                className="discrete_intervals_Color"
                ref={(input) => {
                    this.references.container = input;
                }}
            >
                <div className="content">
                    <span className="icon-container glyphicon glyphicon-cog" onClick={this.handleSelectorShow}></span>
                    <span className="form-control colors-container">
                        {colorNull}
                        {colorTrue}
                        {colorFalse}
                        {colors}
                    </span>
                </div>
            </div>
        );
    }
}

//================== DiscreteIntervals dialog for any Kind ==============

interface IIntervalSelectPopup_forKindOptions extends IPopupOptions {
    value;
    type: string;
    kind: DiscreteIntervalsKind;
    themeObj?: IValuesCollection;
    useFadeShow?: boolean; //LL: 25.11.22
    onChange(value): void;
}

class IntervalSelectPopup_forKind extends React.Component<
    {
        zIndex: number;
        options: IIntervalSelectPopup_forKindOptions;
        glob: IGlob;
        close();
    },
    {
        value;
        hasIntervalError: boolean;
        height?: number;
        width?: number;
    }
> {
    private references: {
        popoverContent?: HTMLElement;
    } = {};

    constructor(props) {
        super(props);

        const valueOrig = $.extend(true, {}, this.props.options.value);

        this.state = {
            value: valueOrig, //this.props.options.value
            hasIntervalError: false,
            height: 500, //LL: as in FormatChooser  ??? can change, depends on current Tab  Reset in DidMount
            width: 530 //LL: as in FormatChooser   sass - 520      Reset in DidMount
        };
    }

    componentDidMount() {
        const dialog = this.references.popoverContent as HTMLElement;
        // VR: needed for JEST testing: "if(dialog != null)"
        if (dialog != null) {
            this.setState(
                _.extend(this.state, {
                    height: dialog.clientHeight,
                    width: dialog.clientWidth
                })
            );
        }
    }

    handleOnChange = (value, hasIntervalError?: boolean) => {
        this.setState({
            value: value,
            hasIntervalError: hasIntervalError
        });

        // if (typeof this.props.options.onChange === 'function') {
        //     this.props.options.onChange(value);
        // }
    };

    closeButtonHandler = () => {
        let hasError = this.state.hasIntervalError;

        if (hasError != true) {
            let errors = validateWhole(this.state.value, this.props.options.type);

            if (errors.length > 0) {
                hasError = true;
            }
        }

        if (hasError === true) {
            //LL: 28.05.19:  no:
            //this.props.options.glob.AppActions.showNotification_Warning('Configuration is not valid. Some fields have wrong value');
        } else {
            if (typeof this.props.options.onChange === 'function') {
                //LL: 10.05.23: BL values to boolean
                let vvv = $.extend(true, {}, this.state.value);

                if (this.props.options.kind === DiscreteIntervalsKind.boolean) {
                    // this.state.value.labels - arr
                    // this.state.value.nullMappedValue

                    if (vvv.nullMappedValue != null && typeof vvv.nullMappedValue === 'string') {
                        vvv.nullMappedValue = vvv.nullMappedValue === 'true';
                    }
                    vvv.labels = _.map(vvv.labels, (v: any) => {
                        //let bValue: boolean = v;
                        let bValue = v;
                        if (typeof v === 'string') {
                            bValue = v === 'true';
                        }
                        return bValue;
                    });
                }
                this.props.options.onChange(vvv);
            }
            this.props.close();
        }
    };

    escapeButtonHandler = () => {
        // if (typeof this.props.options.onChange === 'function') {
        //     this.props.options.onChange(this.state.valueOrig);
        // }
        this.props.close();
    };

    render() {
        const popoverStyle = Utilities.getPopoverStyle(this.props.options, {
            width: this.state.width,
            height: this.state.height
        });
        const errors = validateWhole(this.state.value, this.props.options.type);

        let errorsElement: React.JSX.Element;
        let hasError = this.state.hasIntervalError;

        if (errors.length > 0) {
            hasError = true;
            errorsElement = <div style={{ color: 'red', margin: '10px' }}>{errors.join(', ')}</div>;
        }

        //LL: 25.11.22: PPP
        //LL: when used, background window is faded and cannot scroll
        //    <div className="modal-backdrop fade show"></div>
        //LL: NOTE:
        //   if fadeShow is null, this popup dialog behaves the same in all cases (problem of e.stopPropagation in caller):
        //  When from Config (from a Dialog), stopPropagation must NOT BE
        //  When from Administration/Settings/Options, stopPropagation must BE
        //  When from Administration/Themes, stopPropagation must NOT BE
        let fadeShow = null;

        if (this.props.options.useFadeShow === true) {
            fadeShow = <div className="modal-backdrop fade show"></div>;
        }

        //LL:  as in IntervalsSelect
        return (
            <div className="discrete-intervals">
                <div
                    className={'popover discrete-intervals-popover ' + popoverStyle.side}
                    ref={(input) => {
                        this.references.popoverContent = input;
                    }}
                    style={{
                        display: 'block',
                        left: popoverStyle.left,
                        top: popoverStyle.top,
                        zIndex: this.props.zIndex
                    }}
                >
                    <div className="arrow" style={{ top: popoverStyle.arrowTop }}></div>

                    <h3 className="popover-header">
                        {'Discrete Intervals Scale'}
                        <button
                            type="button"
                            className="close"
                            title="Cancel all changes"
                            onClick={this.escapeButtonHandler}
                        >
                            ×
                        </button>
                    </h3>

                    {errorsElement}

                    <div className="separate-upper-tab">
                        <div className="popover-body">
                            <DiscreteIntervals
                                value={this.state.value}
                                type={this.props.options.type}
                                kind={this.props.options.kind}
                                themeObj={this.props.options.themeObj}
                                glob={this.props.glob}
                                onChange={this.handleOnChange}
                            />
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button
                            className={'btn btn-success' + (hasError ? ' disabled' : '')}
                            onClick={this.closeButtonHandler}
                        >
                            {'OK'}
                        </button>
                        <button className="btn btn-default" onClick={this.escapeButtonHandler}>
                            {'Cancel'}
                        </button>
                    </div>
                </div>
                {fadeShow}
            </div>
        );
    }
}

export class DiscreteIntervals_forKind extends React.Component<
    {
        value;
        type: string;
        kind: DiscreteIntervalsKind;
        notUseRegularTab?: boolean;
        themeObj?: IValuesCollection;
        glob: IGlob;
        onChange(value): void;
    },
    {
        popup?: boolean;
        isInSettingsView?: boolean;
        isInModalDialog?: boolean;
    }
> {
    private references: {
        container?: HTMLDivElement; // ".discrete_intervals_custom"
    } = {};

    constructor(props) {
        super(props);

        this.state = { popup: false };
    }

    componentDidMount() {
        //let a = $(".discrete_intervals_custom").parents().map(function() {
        //    return this.tagName + ' ' + this.className;
        //});
        //
        //let b = $(".discrete_intervals_custom").parents("div").map(function() {
        //    return this.tagName + ' ' + this.className;
        //});
        //
        //let c = $(".discrete_intervals_custom").parents(".settings-view").map(function() {
        //    return this.tagName + ' ' + this.className;
        //});

        //let d = $(".discrete_intervals_custom").parents(".settings-view");
        //let isInSettingsView = (d != null && d.length > 0);
        //
        //let f = $(".discrete_intervals_custom").parents(".modal-dialog");
        //let isInModalDialog = (f != null && f.length > 0);

        //LL: it is better, above sometimes is wrong
        let d2 = $(this.references.container).parents('.settings-view');
        let isInSettingsView2 = d2 != null && d2.length > 0;

        let f2 = $(this.references.container).parents('.modal-dialog');
        let isInModalDialog2 = f2 != null && f2.length > 0;

        this.setState({ isInSettingsView: isInSettingsView2, isInModalDialog: isInModalDialog2 });
    }

    handleChange = (value) => {
        //   value:  { labels, values }
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value); //LL: to caller (ColormappingForNumeric)
        }
    };

    handleClose = () => {
        this.setState({ popup: false });
    };

    handleSelectorShow = (e) => {
        const offset = $(e.target).offset();

        let isInSettingsView = this.state.isInSettingsView;

        if (isInSettingsView === true && this.state.popup === true) {
            e.preventDefault();
            //return;
        }

        //LL: 25.11.22 PPP
        //LL: problem is in e.stopPropagation();
        //  When from Config (from a Dialog), stopPropagation must NOT BE
        //  When from Administration/Settings/Options, stopPropagation must BE
        //  When from Administration/Themes, stopPropagation must NOT BE
        //LL: seems is resolved by useFadeShow: false   !!!  NO
        const useFadeShow = true;

        //LL: 25.11.22: try, see processContainerClick PPP
        //LL: For Issue 69193: Cannot create a "Discrete Mapping" in the Theme of Application - when called not from popup
        //let isDefaultPrevented = e.isDefaultPrevented();
        //let isPropagationStopped = e.isPropagationStopped();

        e.preventDefault();
        // see this.setState({isInSettingsView: isInSettingsView, isInModalDialog: isInModalDialog});
        if (this.state.isInSettingsView === true && useFadeShow) {
            //if (this.state.isInSettingsView === true) {
            //if (this.state.isInSettingsView === true && popup !== true) {
            e.stopPropagation();
        }

        this.props.glob.DialogActions.createPopup<IIntervalSelectPopup_forKindOptions>('custom', {
            top: offset.top,
            left: offset.left,
            value: this.props.value,
            type: this.props.type,
            kind: this.props.kind,
            //notUseRegularTab: this.props.notUseRegularTab, //IL. To prevent Regular intervals tab. Used in Gis icons
            themeObj: this.props.themeObj, //LL: 08.11.19,  sent in DiscreteMappingField  getDiscreteIntervals
            useFadeShow: useFadeShow, //LL: 25.11.22 PPP
            onChange: this.handleChange,
            close: this.handleClose, //LL: 25.11.22 PPP
            component: IntervalSelectPopup_forKind
        });

        this.setState({ popup: true });
    };

    render() {
        const { value } = this.props;

        let labels; //LL: labels are "colors", "icons", "dates", etc
        let labelNull; //LL: 14.11.19: nullMappedValue
        let labelTrue, labelFalse; //LL: 26.10.21
        let specValuesAreNull =
            value == null ||
            (value.nullMappedValue == null && value.trueMappedValue == null && value.falseMappedValue == null);

        if (value == null || (value.values == null && specValuesAreNull)) {
            labels = <em className="empty" onClick={this.handleSelectorShow}></em>;
        } else {
            //LL:  { kind: DiscreteIntervalsKind.label, columnHeader: "Label", emptyMappedValue: "", renderComponent: LabelRenderComponent, renderComponentResult }
            let kindDescrObj = getKindDescrObject(this.props.kind);

            if (value.values != null) {
                //LL: to calculate tooltips:   (see getValue)
                let values = value.values.slice(0);

                if (this.props.type === 'time') {
                    values = _.map(values, (dateString: string) => {
                        dateString = convertTimeValueAsDateToString(dateString);
                        return dateString;
                    });
                }
                values.push(Infinity);
                values.unshift(-Infinity);

                //let labelTxt = kindDescrObj.columnHeader;
                let N = value.labels.length;

                //LL: labels are "colors", "icons", "dates", etc
                labels = _.map(value.labels, (label, i) => {
                    const title = getIntervalPlaceholderValue(values[i], values[i + 1], this.props.type, true);

                    return (
                        <kindDescrObj.renderComponentResult
                            key={i}
                            label={label}
                            title={title}
                            isLast={i === N - 1}
                            glob={this.props.glob}
                        />
                    );
                });
            }

            if (this.props.type === 'boolean') {
                if (value.trueMappedValue != null) {
                    const title = getIntervalPlaceholderValue(null, true, this.props.type, true);

                    labelTrue = (
                        <kindDescrObj.renderComponentResult
                            key={-2}
                            label={value.trueMappedValue}
                            title={title}
                            isLast={false}
                            glob={this.props.glob}
                        />
                    );
                }
                if (value.falseMappedValue != null) {
                    const title = getIntervalPlaceholderValue(null, false, this.props.type, true);

                    labelFalse = (
                        <kindDescrObj.renderComponentResult
                            key={-3}
                            label={value.falseMappedValue}
                            title={title}
                            isLast={false}
                            glob={this.props.glob}
                        />
                    );
                }
            }

            if (value.nullMappedValue != null) {
                const title = getIntervalPlaceholderValue(null, null, this.props.type, true);

                labelNull = (
                    <kindDescrObj.renderComponentResult
                        key={-1}
                        label={value.nullMappedValue}
                        title={title}
                        isLast={false}
                        glob={this.props.glob}
                    />
                );
            }
        }

        return (
            <div
                className="discrete_intervals_custom"
                ref={(input) => {
                    this.references.container = input;
                }}
            >
                <div className="content">
                    <span className="icon-container glyphicon glyphicon-cog" onClick={this.handleSelectorShow}></span>
                    <span className="form-control values-container">
                        {labelNull}
                        {labelTrue}
                        {labelFalse}
                        {labels}
                    </span>
                </div>
            </div>
        );
    }
}
